var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
};

document.documentElement.style.setProperty(
  "--viewport-height",
  `${window.innerHeight}px`
);

// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement("script");
  script.src = url;
  document.body.appendChild(script);
};

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, comma, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    if (comma == false) dollars = dollars.replace(/,/g, ' ');

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0, false);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, true, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, true, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, {
        capture: true,
        passive: isScrollEvent,
      });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, {
        capture: false,
        passive: isScrollEvent,
      });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent =
    ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !==
    -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, {
        capture: useCapture,
        passive: isScrollEvent,
      });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class GlobalScrollListener {
  constructor() {
    this.callbacks = new Map();
    this.listenerIdCounter = 0;
    this.isListening = false;
    this.boundRunCallbacks = this.runCallbacks.bind(this);
  }

  addScrollListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.callbacks.set(key, boundFunction);

    if (!this.isListening) {
      window.addEventListener("scroll", this.boundRunCallbacks, {
        passive: true,
      });
      this.isListening = true;
    }

    return {
      removeScrollListener: () => this.removeScrollListenerFunction(key),
    };
  }

  removeScrollListenerFunction(key) {
    if (this.callbacks.has(key)) {
      this.callbacks.delete(key);
    }

    if (this.callbacks.size === 0 && this.isListening) {
      window.removeEventListener("scroll", this.boundRunCallbacks);
      this.isListening = false;
    }
  }

  runCallbacks() {
    this.callbacks.forEach((callback) => callback());
  }
}

const scrollListener = new GlobalScrollListener();

class Responsive {
  constructor(enableGeneralBreakpointChange, trackWindowHeight) {
    this.settings();

    this.trackWindowHeight = trackWindowHeight;
    this.generalBreakpointChange = enableGeneralBreakpointChange;
    this.currentBreakpoint = this.getCurrentBreakpoint();
    this.breakpointListeners = new Map(); // Stores listeners with their status
    this.resizeCallbacks = new Map();
    this.listenerIdCounter = 0;

    this.setWindowHeight();
    this.initResizeListener();
  }

  initResizeListener() {
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.boundHandleResize);
  }

  settings() {
    this.matchBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      tablet_and_up: "(min-width: 768px)",
      pocket: "(max-width: 1024px)",
      lap_and_up: "(min-width: 1025px)",
      desktop: "(min-width: 1280px)",
      desktop_wide: "(min-width: 1440px)",
    };

    this.currentBreakpoints = {
      phone: "(max-width: 640px)",
      pocket: "(max-width: 1024px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      desktop: "(min-width: 1025px)",
    };
  }

  handleResize() {
    const newBreakpoint = this.getCurrentBreakpoint();

    if (this.generalBreakpointChange) {
      // Check for general breakpoint change
      if (this.currentBreakpoint !== newBreakpoint) {
        document.dispatchEvent(
          new CustomEvent("breakpoint:changed", {
            detail: {
              previousBreakpoint: this.currentBreakpoint,
              currentBreakpoint: newBreakpoint,
            },
          })
        );
      }
    }

    // Additional check for specific breakpoint
    this.breakpointListeners.forEach((value, key) => {
      const isCurrentlyInBreakpoint = this.matchesBreakpoint(key);
      if (value !== isCurrentlyInBreakpoint) {
        this.breakpointListeners.set(key, isCurrentlyInBreakpoint);
        document.body.dispatchEvent(
          new CustomEvent(`breakpoint:${key}`, {
            detail: {
              matches: isCurrentlyInBreakpoint,
            },
          })
        );
      }
    });

    this.currentBreakpoint = newBreakpoint;

    this.setWindowHeight();

    // Run additional registered resize callbacks
    this.runCallbacks();
  }

  setWindowHeight() {
    if (this.trackWindowHeight) {
      document.documentElement.style.setProperty(
        "--window-inner-height",
        `${window.innerHeight}px`
      );
    }
  }

  matchesBreakpoint(breakpoint) {
    const query = this.matchBreakpoints[breakpoint];
    return window.matchMedia(`screen and ${query}`).matches;
  }

  getCurrentBreakpoint() {
    for (const [key, query] of Object.entries(this.currentBreakpoints)) {
      if (window.matchMedia(`screen and ${query}`).matches) {
        return key;
      }
    }
  }

  addBreakpointListener(breakpoint) {
    if (!this.matchBreakpoints[breakpoint]) {
      console.error("Breakpoint does not exist:", breakpoint);
      return;
    }

    if (this.breakpointListeners.has(breakpoint)) {
      console.warn("Listener already exists for breakpoint:", breakpoint);
      return;
    }

    const isInBreakpoint = this.matchesBreakpoint(breakpoint);
    this.breakpointListeners.set(breakpoint, isInBreakpoint);
  }

  addResizeListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.resizeCallbacks.set(key, boundFunction);

    return {
      removeResizeListener: () => this.removeResizeListenerFunction(key),
    };
  }

  removeResizeListenerFunction(key) {
    if (this.resizeCallbacks.has(key)) {
      this.resizeCallbacks.delete(key);
    }
  }

  runCallbacks() {
    this.resizeCallbacks.forEach((callback) => callback());
  }
}

const responsive = new Responsive(false, true);

let alreadyDelegated = false;
class Popup {
  constructor(element, specialOverlay) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    if (
      specialOverlay == true &&
      new Responsive().matchesBreakpoint("pocket")
    ) {
      this.pageOverlayElement = document.querySelector(".localizationOverlay");
    }

    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="open-modal"]',
      this.openModal.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-modal"]',
      this.closeModal.bind(this)
    );
    document.addEventListener(
      "posted_successfully",
      this.openModalSpecial.bind(this)
    );

    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  openModal() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(
      event.target.getAttribute("aria-controls")
    );
    this.activeModal.setAttribute("aria-hidden", "false");
    this.activeModal.style.display = "block";
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    var focus = this.activeModal.querySelector("[data-scrollable]");

    setTimeout(() => {
      trapFocus(this.activeModal);
    }, 100);
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
  }
  openModalSpecial() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(event.detail.id);
    this.activeModal.setAttribute("aria-hidden", "false");
    var focus = this.element.querySelector("[data-scrollable]");
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    trapFocus(this.activeModal);
  }
  closeModal() {
    this.activeModal = document.body.querySelector(
      '.Popup[aria-hidden="false"]'
    );
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );
    this.onClose();
    bodyScrollLock.clearAllBodyScrollLocks();
    if (!this.activeModal.classList.contains("customerAccount--Popup")) {
      this.activeModal.removeAttribute("style");
    }
  }

  onClose() {
    this.transitionEndHandler = () => this.handleTransitionEnd();
    this.activeModal.addEventListener(
      "animationend",
      this.transitionEndHandler
    );
    this.activeModal.setAttribute("aria-hidden", "true");
  }
  handleTransitionEnd() {
    this.activeModal.style.display = "none";
    this.activeModal.removeEventListener(
      "animationend",
      this.transitionEndHandler
    );
  }
}

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();
    this.applyColorScheme();
  }

  applyColorScheme() {
    const productModule = document.querySelector('.product-module');
    const colorGroupClass = Array.from(productModule.classList).find(className => className.includes('colorGroup'));
    document.querySelector('.pswp').classList.add(colorGroupClass);
  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    responsive.addResizeListener(this, this.syncHeight.bind(this));
    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );
    this.delegateElement.on(
      "click",
      ".product-module__product-slider--image",
      this.initPhotoSwipeFromImageClick.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoswiperClose.bind(this)
    );

    this.onPointerUpBinder = this.onPointerUp.bind(this);
    this.onPointerDownBinder = this.onPointerDown.bind(this);
    responsive.addBreakpointListener("lap_and_up");
    this.delegateRoot.on(
      "breakpoint:lap_and_up",
      this.toggleMoveZoom.bind(this)
    );
    this.toggleMoveZoom();

    if (responsive.matchesBreakpoint('pocket') && document.querySelector('[data-zoom-type="image"]')) {
      this.delegateElement.on(
        "click",
        '.product-module__product-slider--image',
        this.initPhotoSwipeFromPhotoTap.bind(this)
      );
    }
  }

  toggleMoveZoom(e) {
    if (responsive.matchesBreakpoint("lap_and_up")) {
      this.delegateRoot.on(
        "pointerdown",
        "[data-move]",
        this.onPointerDownBinder
      );
      this.delegateRoot.on("pointerup", "[data-move]", this.onPointerUpBinder);
    } else {
      this.delegateRoot.off(
        "pointerdown",
        "[data-move]",
        this.onPointerDownBinder
      );
      this.delegateRoot.off("pointerup", "[data-move]", this.onPointerUpBinder);
    }
  }

  onPointerDown(e) {
    this.timeout = setTimeout(() => {
      e.target.closest(".pswp__container")?.classList.add("move");
    }, 150);
  }

  onPointerUp(e) {
    if (this.timeout) {
      clearInterval(this.timeout);
    }
    e.target.closest(".pswp__container")?.classList.remove("move");
  }

  photoswiperClose() {
    if (this.photoSwipeInstance) {
      this.photoSwipeInstance.close;
    }
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  sortImageArray(images) {
    return images.sort((a, b) => {
      const positionA = parseInt(a.closest(".product-module__product-slider-element").getAttribute("data-image-position"));
      const positionB = parseInt(b.closest(".product-module__product-slider-element").getAttribute("data-image-position"));
      return positionA - positionB;
    });
  }

  initPhotoSwipeFromPhotoTap(e) {
    if (e.target.closest('[data-action="open-product-zoom"]')
      || e.target.closest('.product-module__product-highlight')
      || document.querySelector('.product-module__product-highlight-details[aria-hidden="false"]')
    ) return;
    e.target.closest('.product-module__product-slider-cell').querySelector('[data-action="open-product-zoom"]').click();
  }

  initPhotoSwipe(event, target) {
    if (document.querySelector('.product-module__product-highlight-details[aria-hidden="false"]')) return;

    var images = [],
      index = 0;
    if (this.slideshow) {
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (
          item.classList.contains("product-module__product-slider-cell--zoom")
        ) {
          if (item.querySelector("img")) {
            images.push(item.querySelector("img"));
          }
        }
      });
    } else {
      images.push(
        document.querySelector(".product-module__product-slider-image")
      );
    }

    const imagePosition = parseInt(
      target
        .nextElementSibling
        .getAttribute("data-image-position")
    );

    images = this.sortImageArray(images);

    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(imagePosition)
    );
  }

  initPhotoSwipeFromImageClick(event, target) {
    // Check if the current breakpoint is "pocket". If it is, return without doing anything.
    if (
      responsive.matchesBreakpoint("pocket") ||
      event.target.closest(".product-module__product-highlight") ||
      document.querySelector('.product-module__product-highlight-details[aria-hidden="false"]')
    ) {
      return;
    }

    // Create an array of images from the siblings of the target element.
    var images = [];
    const siblings = Array.from(target.parentElement.children);

    siblings.forEach((item) => {
      if (
        item.classList.contains("product-module__product-slider-cell--zoom") &&
        item.querySelector("img")
      ) {
        images.push(item.querySelector("img"));
      }
    });

    // Get the image position from the target element's data attribute.
    const imagePosition = parseInt(
      target
        .querySelector(".product-module__product-slider-element")
        .getAttribute("data-image-position")
    );

    images = this.sortImageArray(images);

    // Create the PhotoSwipe instance using the images and image position.
    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      imagePosition
    );
  }

  createPhotoSwipeItemsFromImages(images) {
    return images.map(function (image) {
      var maxWidth = parseInt(image.getAttribute("data-max-width")),
        maxHeight = parseInt(image.getAttribute("data-max-height")),
        maxDimension = responsive.matchesBreakpoint("pocket") ? 1200 : 2200,
        reduceFactor = 1.0;

      if (maxWidth >= maxHeight) {
        reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
      } else {
        reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
      }
      var requestedWidth = Math.floor(maxWidth / reduceFactor);
      var requestedHeight = Math.floor(maxHeight / reduceFactor);
      return {
        msrc: image.currentSrc || image.src,
        w: requestedWidth,
        h: requestedHeight,
        initialZoomLevel: 0.65,
        src: image.dataset.originalSrc,
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: false,
        history: false,
        closeOnVerticalDrag: true,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "orig",
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.35;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
            ".product-module__product-slider-cell--zoom img"
          ),
            thumbnail = allThumbnail[index],
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      }
    );

    this.photoSwipeInstance.listen(
      "beforeChange",
      this.onslideChanged.bind(this)
    );
    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      this.photoSwipeInstance.next
    );
    this.photoSwipeInstance.listen("close", this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  onslideChanged() {
    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .removeAttribute("disabled");
    }

    if (
      this.photoSwipeInstance.getCurrentIndex() + 1 ===
      this.photoSwipeInstance.options.getNumItemsFn()
    ) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .removeAttribute("disabled");
    }
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}

class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.dropdown = this.element.querySelector(".RevolutionSelectbox");
    this.isOpen = false;
    this.mainDropdown = this.element.querySelector(
      ".RevolutionSelectbox--Content"
    );

    this.mainDropdownContent = this.element.querySelector(
      ".RevolutionSelectbox--InnerContent"
    );
    this.mainButton = this.element.querySelector(
      ".RevolutionSelectbox--Button"
    );

    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector(
      "[name=" + this.connectedSelect + "]"
    );
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
        "[name2=" + this.connectedSelect + "]"
      );
    }
    if (this.popover == true) {
      this.mainDropdown.classList.remove("RevolutionSelectbox--animation");
      this.mainDropdown.classList.add("PopoverContent");
      if (this.changeOverlay) {
        this.pageOverlayElement = document.querySelector(
          ".localizationOverlay"
        );
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }
    this.bindEvents();
    this.initSelectbox();
  }

  bindEvents() {
    this.onClickOutsideListener = this.onClickOutside.bind(this);
    this.domDelegate.on(
      "click",
      "[data-action=toggle-selectbox]",
      this.toggleDropdown.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      "keypress",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-change]",
      this.selectboxChange.bind(this)
    );

    this.delegateBody.on("menu:open", this.onClickOutside.bind(this));
    this.domDelegate.on("click", "body", this.onClickOutside.bind(this));
  }

  selectboxChange() {
    var value = event.target.getAttribute("data-value");
    var selectboxID = event.target.getAttribute("data-selectboxid");
    var innerContent = event.target.innerHTML;
    var selEl = this.element.querySelector("#" + selectboxID);
    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
    } else {
      selEl.value = value;
      if (event.target.dataset.id !== null) {
        selEl.dataset.id = event.target.dataset.id;
      }
    }
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      innerContent;

    if (this.mainButton.querySelector(".u-p4")) {
      const elem = this.mainButton.querySelector(".u-p4");
      elem.classList.remove("u-p4");
      elem.classList.add("u-p3");
    }
    if (this.element.classList.contains("product-module__dropdown-selector")) {
      this.element
        .querySelector('.RevolutionSelectbox--Item[disabled="true"]')
        .removeAttribute("disabled");
      event.target.setAttribute("disabled", "true");
    }
    if (event.target.dataset.selectboxid == "country_code_selector") {
      this.element
        .querySelector(".RevolutionSelectbox--Item[selected='selected']")
        .setAttribute("selected", "false");
      event.target.setAttribute("selected", "selected");
      this.element.dispatchEvent(
        new CustomEvent("change:countrySelector", {
          bubbles: true,
          detail: {
            currency: event.target.dataset.currency,
            country: event.target.value,
            languages: event.target.dataset.languages,
          },
        })
      );
    } else if (
      event.target.dataset.selectboxid == "product-module__notify-selector"
    ) {
      this.element.dispatchEvent(
        new CustomEvent("notify:change", {
          bubbles: true,
          detail: {
            id: event.target.dataset.id,
          },
        })
      );
    }
    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (
      !withinBoundaries ||
      event.target.classList.contains("FiltersDesktopWrapper")
    ) {
      this.closeDropdown(this.element);
    }
  }

  selectboxSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    var value = event.target.getAttribute("data-value");
    var dataName = event.target.getAttribute("data-name");
    this.selectbox.value = value;
    this.closeDropdown(this.element);
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      dataName;
    this.selectbox.parentElement.submit();
  }

  initSelectbox() {
    const selectedItem = this.mainDropdown.querySelector(
      '[selected="selected"]'
    ),
      titleElement = this.element.querySelector(".RevolutionSelectbox--Title");
    if (selectedItem) {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
    }

    trapFocus(this.element);
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {
    event.preventDefault();

    if (this.isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {
    // Dispatch "close:search" and "menu:close" events on the element.
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );
    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );

    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(
      target.parentElement.parentElement.children
    ).filter((item) => item.classList.contains("RevolutionSelectbox"));

    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      item
        .querySelector(".RevolutionSelectbox--Button")
        .setAttribute("aria-expanded", false);
      item
        .querySelector(".RevolutionSelectbox--Content")
        .setAttribute("aria-hidden", true);
      item.querySelector(".RevolutionSelectbox--Content").style.display =
        "none";
    });

    // If the dropdown is a popover, show the page overlay and disable body scrolling.
    const focus = this.element.querySelector("[data-scrollable]");
    console.log(focus)
    bodyScrollLock.clearAllBodyScrollLocks();
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);

    if (this.popover) {
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
      );

      trapFocus(this.mainDropdown);
      if (
        document.querySelector("#Drawer").getAttribute("aria-expanded") ===
        "true"
      ) {
        document.querySelector(".Drawer--Wrapper").style.overflow = "visible";
      }
    }

    // Show the dropdown content for the target element and set its state to "expanded".
    const contentElement = target.parentElement.querySelector(
      ".RevolutionSelectbox--Content"
    );
    target.setAttribute("aria-expanded", "true");
    contentElement.style.display = "block";
    contentElement.style.height = `${contentElement.offsetHeight}px`;

    if (this.popover) {
      setTimeout(() => {
        contentElement.setAttribute("aria-hidden", "false");
      }, 20);
    } else {
      contentElement.setAttribute("aria-hidden", "false");
    }

    this.isOpen = true;
    window.addEventListener("click", this.onClickOutsideListener);
  }

  closeDropdown(target) {
    var closestDropdown = target.closest(".RevolutionSelectbox");
    if (closestDropdown === null) {
      var closestDropdown = target.querySelector("[aria-expanded='true']");
      if (closestDropdown) {
        closestDropdown = closestDropdown.parentElement;
      } else {
        return;
      }
    }
    closestDropdown
      .querySelector(".RevolutionSelectbox--Button")
      .setAttribute("aria-expanded", false);
    closestDropdown
      .querySelector(".RevolutionSelectbox--Content")
      .setAttribute("aria-hidden", true);
    setTimeout(() => {
      closestDropdown.querySelector(
        ".RevolutionSelectbox--Content"
      ).style.display = "none";
    }, 300);

    if (this.popover == true) {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
      );

      const menuDrawer = document.querySelector("#Drawer");
      if (menuDrawer.getAttribute("aria-expanded") == "true") {
        document.querySelector(".Drawer--Wrapper").style.overflow = "auto";
      }
      if (!this.element.closest('country-modal')) {
        bodyScrollLock.clearAllBodyScrollLocks();
        document.body.classList.remove("scrollLock");
      }
    }
    this.isOpen = false;
    removeTrapFocus(this.mainDropdownContent);
    window.removeEventListener("click", this.onClickOutsideListener);
  }
}

class Form {
  constructor() { }

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageLoader = document.querySelector(".pageLoader");
    this.cartCount = document.querySelector(".cart-count");
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );
  }

  async addToCart(event) {
    event.preventDefault();
    const addToCartButton = event.target;
    addToCartButton.setAttribute("disabled", "disabled");
    this.showPageLoader();

    const formElement = addToCartButton.closest("form");
    const formHelper = new Form();
    const serializedData = formHelper.serialize(formElement);

    try {
      const response = await this.submitCartForm(serializedData);
      const responseData = await response.json(); // Extracting JSON data
      let itemCount;
      if (window.theme.cartMode === "page") {
        const cartResponse = await this.getCartItemNumber();
        const cartCountNum = await cartResponse.json();
        itemCount = cartCountNum.item_count;
      }

      this.handleSuccessResponse(responseData, serializedData, addToCartButton, itemCount);
      return responseData; // Returning the JSON data for later use
    } catch (errorContent) {
      this.handleErrorResponse(errorContent, addToCartButton);
    } finally {
      this.closeDrawer();
      this.hidePageLoader();
    }
  }

  closeDrawer() {
    const closeButton = document.querySelector(".custom-close-product");
    if (closeButton) {
      closeButton.click();
    }
  }

  showPageLoader() {
    this.pageLoader.style.width = "100%";
  }

  hidePageLoader() {
    this.pageLoader.style.left = "unset";
    this.pageLoader.style.right = "0px";
    this.pageLoader.style.width = "0%";

    setTimeout(() => {
      this.pageLoader.style.left = "0px";
      this.pageLoader.style.right = "unset";
    }, 550);
  }

  async submitCartForm(data) {
    const response = await fetch(`${window.routes.localeRootUrl}/cart/add.js`, {
      body: JSON.stringify(data),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    if (!response.ok) {
      const errorContent = await response.json();
      throw errorContent;
    }

    return response;
  }

  async getCartItemNumber() {
    const response = await fetch(`${window.routes.localeRootUrl}/cart.js`, {
      credentials: "same-origin",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    if (!response.ok) {
      const errorContent = await response.json();
      throw errorContent;
    }

    return response;
  }

  handleSuccessResponse(responseData, data, button, itemCount) {
    const innerContent = this.templateSuccessInfo(responseData);

    if (document.querySelector('cart-drawer[aria-expanded="false"]')) {
      this.displayInfo(innerContent);
    }

    if (window.theme.cartMode === "page") {
      if (itemCount) {
        this.cartCount.classList.add("active");
        this.cartCount.innerHTML = itemCount;
        setTimeout(() => {
          this.cartCount.classList.remove("active");
        }, 2500);
      }

      button.removeAttribute("disabled");
      return;
    }

    if (window.location.href.includes("cart")) {
      window.location.reload();
      return;
    }

    button.removeAttribute("disabled");

    this.element.dispatchEvent(
      new CustomEvent("product:added", {
        bubbles: true,
        detail: {
          variant: data.id,
          quantity: data.quantity,
          cartData: responseData, // Attaching the response data to the event
        },
      })
    );
  }

  templateSuccessInfo(data) {
    const icon = `<svg class="svg-success" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.11133 10.5C1.11133 5.59078 5.09102 1.61108 10.0002 1.61108C12.3577 1.61108 14.6186 2.54759 16.2856 4.21458C17.9526 5.88157 18.8891 8.14249 18.8891 10.5C18.8891 15.4092 14.9094 19.3889 10.0002 19.3889C5.09102 19.3889 1.11133 15.4092 1.11133 10.5ZM8.50577 14.8111L15.8058 7.51664L15.8169 7.52775C16.1237 7.22093 16.1237 6.72346 15.8169 6.41664C15.5101 6.10981 15.0126 6.10981 14.7058 6.41664L8.51688 12.6L5.30577 9.38886C4.99895 9.08204 4.50149 9.08204 4.19466 9.38886C3.88784 9.69569 3.88784 10.1931 4.19466 10.5L8.50577 14.8111Z" fill="#34CD5F"/>
    </svg>
    `;
    const string = window.cartStrings.added_to_cart;

    return `
      <div class="atc-info__image">
        <img src="${data.image}" alt="${data.featured_image.alt}">
      </div>
      <div class="atc-info__content">
        <div class="atc-info__title u-s2 mb-xs">${string}</div>
       <div class="atc-info__variant u-p3">
  ${data.product_title}${data.variant_title ? ", " + data.variant_title.replace(/ \/ /g, ", ") : ""
      }
</div>
      </div>
      <div class="atc-info__icon">${icon}</div>
   `;
  }

  templateErrorInfo(data) {
    const icon = `<svg class=svg-error width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.11111 10C1.11111 5.0908 5.09081 1.11111 10 1.11111C12.3575 1.11111 14.6184 2.04762 16.2854 3.71461C17.9524 5.3816 18.8889 7.64252 18.8889 10C18.8889 14.9092 14.9092 18.8889 10 18.8889C5.09081 18.8889 1.11111 14.9092 1.11111 10ZM14.4444 14.5C14.7513 14.1932 14.7513 13.6957 14.4444 13.3889L11.1111 10.0444L14.5389 6.62778C14.7374 6.4293 14.8149 6.14001 14.7422 5.86888C14.6696 5.59775 14.4578 5.38597 14.1867 5.31332C13.9156 5.24067 13.6263 5.31819 13.4278 5.51667L10 8.94445L6.57223 5.47778C6.37374 5.2793 6.08445 5.20178 5.81332 5.27443C5.54219 5.34708 5.33042 5.55886 5.25777 5.82999C5.18512 6.10112 5.26263 6.39041 5.46111 6.58889L8.88889 10.0444L5.55556 13.4C5.35708 13.5985 5.27956 13.8878 5.35221 14.1589C5.42486 14.43 5.63664 14.6418 5.90777 14.7145C6.1789 14.7871 6.46819 14.7096 6.66667 14.5111L10 11.1667L13.3333 14.5C13.6402 14.8068 14.1376 14.8068 14.4444 14.5Z" fill="#232323"/>
    </svg>
    `;

    return `
    <div class="atc-info__content">
      <div class="atc-info__title u-s2 mb-xs">${data.description}</div>
    
    </div>
    <div class="atc-info__icon">${icon}</div>

 `;
  }

  handleErrorResponse(errorContent, button) {
    const innerContent = this.templateErrorInfo(errorContent);

    this.displayInfo(innerContent);
    button.removeAttribute("disabled");

    this.element.dispatchEvent(
      new CustomEvent("product:error", {
        bubbles: true
      })
    );
  }

  displayInfo(element) {
    const infoDiv = document.createElement("div");
    infoDiv.classList.add("atc-info__wrapper");
    infoDiv.setAttribute("aria-hidden", "true");
    infoDiv.innerHTML = element;

    document.body.appendChild(infoDiv);
    requestAnimationFrame(() => {
      infoDiv.setAttribute("aria-hidden", "false");
    });
    setTimeout(() => {
      infoDiv.setAttribute("aria-hidden", "true");
      setTimeout(() => {
        infoDiv.remove();
      }, 300);
    }, 2500);
  }
}

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.allDropdowns = document.querySelectorAll(".Dropdown");
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    this.bindEvents();
  }

  bindEvents() {
    // Bind event for general dropdown toggle
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    let selector;
    switch (this.breakpoint) {
      case "desktop":
        // For lap-and-up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case "pocket":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on("click", selector, this.toggleDropdown.bind(this));
    }
  }

  openDropdown(elem, target) {
    this.lock = true;
    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    this.allDropdowns.forEach((dropdown) => {
      if (
        dropdown !== target.closest(".Dropdown") &&
        dropdown.querySelector("[aria-expanded='true']") &&
        !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown);
      }
    });

    DropdownButton.setAttribute("aria-expanded", "true");
    new RevolutionAnimation(DropdownContent, "true").slideDown();

    setTimeout(() => {
      this.lock = false;
    }, 300);
  }

  closeDropdown(elem) {
    this.lock = true;
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", false);
    setTimeout(() => {
      if (DropdownContent.getAttribute("aria-hidden") == "false") {
        DropdownContent.setAttribute("aria-hidden", "true");
      }

      this.lock = false;
    }, 300);
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";

    if (!this.lock) {
      if (isOpen) {
        // If dropdown is open, close it
        this.closeDropdown(mainDropdown, target);
      } else {
        // If dropdown is closed, open it
        this.openDropdown(mainDropdown, target);
      }
    }
  }
}

const allDropdowns = new Dropdown();

class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (this.element.querySelector('.swiper-slide img')) {
      this.slidesToPreload = this.getSlidesPerView(this.initialConfig);
    }

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  getSlidesPerView(config) {
    const calculateSlides = (view) => Math.ceil(view >= 3 ? 3 : view || 3);

    const mobileSlidesPerView = config.slidesPerGroup ? calculateSlides(config.slidesPerGroup) : calculateSlides(config.slidesPerView);
    const desktopSlidesPerView = config.breakpoints && config.breakpoints['1025']
      ? (config.breakpoints['1025'].slidesPerGroup ? calculateSlides(config.breakpoints['1025'].slidesPerGroup) : calculateSlides(config.breakpoints['1025'].slidesPerView))
      : mobileSlidesPerView;

    const n = responsive.matchesBreakpoint('pocket') ? mobileSlidesPerView : desktopSlidesPerView;

    return n;
  }

  preloadNextSlides() {
    const n = this.getSlidesPerView(this.initialConfig);

    let delay = 0;
    if (!this.firstTime) {
      delay = 250;
      this.firstTime = !this.firstTime;
    }

    setTimeout(() => {
      this.swiperElement
        .slides
        .slice(this.swiperElement.activeIndex, this.swiperElement.activeIndex + n + 1)
        .map(slide => slide.querySelector('img[loading="lazy"]'))
        .forEach(img => img && img.setAttribute('loading', 'eager'));
    }, delay)
  };

  selectCell(index) {
    const swiper = this.swiperElement;
    const perView = swiper.params.slidesPerView;
    const isDesktop = responsive.matchesBreakpoint("lap_and_up");

    if (isDesktop && perView > 1) {
      if (swiper.params.loop) {
        this.selectCellInLoop(swiper, index, perView);
      } else {
        this.selectCellNormal(swiper, index, perView);
      }
    } else {
      // Mobile (slidesPerView: 1) - simple selection, no complex positioning needed
      if (swiper.params.loop) {
        const realSlidesCount = this.getRealSlidesCount(swiper);
        const normalizedIndex = ((index % realSlidesCount) + realSlidesCount) % realSlidesCount;
        swiper.slideToLoop(normalizedIndex, 300);
      } else {
        swiper.slideTo(index, 300);
      }
    }
  }

  getRealSlidesCount(swiper) {
    // Count slides without duplicates created by loop mode
    return swiper.slides.filter(slide =>
      !slide.classList.contains('swiper-slide-duplicate')
    ).length;
  }

  selectCellInLoop(swiper, targetIndex, perView) {
    const realSlidesCount = this.getRealSlidesCount(swiper);
    const normalizedIndex = ((targetIndex % realSlidesCount) + realSlidesCount) % realSlidesCount;

    // Handle last slides differently due to loop positioning issues
    const isLastSlide = normalizedIndex >= realSlidesCount - Math.ceil(perView);

    if (isLastSlide) {
      this.handleLastSlideInLoop(swiper, normalizedIndex);
    } else {
      // Standard positioning for other slides
      swiper.slideToLoop(normalizedIndex, 300);

      // Verify positioning after animation completes
      setTimeout(() => {
        if (swiper.realIndex !== normalizedIndex) {
          this.correctLoopPosition(swiper, normalizedIndex);
        }
      }, 350);
    }
  }

  handleLastSlideInLoop(swiper, targetIndex) {
    // For last slides, use a more aggressive positioning approach
    // Method 1: Direct slideToLoop
    swiper.slideToLoop(targetIndex, 300);

    // Method 2: If slideToLoop fails, use manual positioning
    setTimeout(() => {
      const currentRealIndex = swiper.realIndex;
      if (currentRealIndex !== targetIndex) {
        this.manuallyPositionSlide(swiper, targetIndex);
      }
    }, 350);
  }

  manuallyPositionSlide(swiper, targetIndex) {
    // Find the actual slide element for our target index
    const targetSlide = this.findRealSlideByIndex(swiper, targetIndex);

    if (!targetSlide) {
      return;
    }

    // Calculate positioning to put this slide at the leftmost position
    const swiperRect = swiper.el.getBoundingClientRect();
    const slideRect = targetSlide.getBoundingClientRect();

    // Calculate how much we need to translate
    const currentTranslate = swiper.getTranslate();
    const adjustment = slideRect.left - swiperRect.left;
    const targetTranslate = currentTranslate - adjustment;

    // Apply bounds checking using Swiper's built-in methods
    const maxTranslate = swiper.maxTranslate();
    const minTranslate = swiper.minTranslate();
    const boundedTranslate = Math.max(maxTranslate, Math.min(minTranslate, targetTranslate));

    // Apply the translation with animation
    swiper.wrapperEl.style.transitionDuration = '300ms';
    swiper.setTranslate(boundedTranslate);

    // Update swiper state after positioning
    setTimeout(() => {
      swiper.updateProgress();
      swiper.updateSlidesClasses();
      swiper.realIndex = targetIndex;
      swiper.emit('slideChange');
      swiper.wrapperEl.style.transitionDuration = '';
    }, 50);
  }

  findRealSlideByIndex(swiper, realIndex) {
    // Find the slide element that corresponds to our real index
    for (let i = 0; i < swiper.slides.length; i++) {
      const slide = swiper.slides[i];

      // Skip duplicate slides created by loop mode
      if (slide.classList.contains('swiper-slide-duplicate')) {
        continue;
      }

      // Check the data attribute that Swiper sets
      const slideIndex = parseInt(slide.getAttribute('data-swiper-slide-index'));

      if (slideIndex === realIndex) {
        return slide;
      }
    }

    return null;
  }

  correctLoopPosition(swiper, expectedIndex) {
    // Try slideToLoop again with no animation
    swiper.slideToLoop(expectedIndex, 0);

    // If still incorrect, use manual positioning
    setTimeout(() => {
      if (swiper.realIndex !== expectedIndex) {
        this.manuallyPositionSlide(swiper, expectedIndex);
      }
    }, 50);
  }

  selectCellNormal(swiper, index, perView) {
    const total = swiper.slides.length;
    const maxStart = Math.max(0, total - Math.ceil(perView));
    const target = Math.min(Math.max(index, 0), maxStart);
    swiper.slideTo(target, 300);
  }

  // Alternative method: Reset loop and reposition (desktop only, for stubborn last slide cases)
  selectCellWithLoopReset(index) {
    const swiper = this.swiperElement;
    const perView = swiper.params.slidesPerView;
    const isDesktop = responsive.matchesBreakpoint("lap_and_up");

    // Only use complex positioning on desktop with multiple slides per view
    if (!isDesktop || !swiper.params.loop || perView <= 1) {
      return this.selectCell(index);
    }

    const realSlidesCount = this.getRealSlidesCount(swiper);
    const normalizedIndex = ((index % realSlidesCount) + realSlidesCount) % realSlidesCount;

    // Temporarily disable loop
    swiper.loopDestroy();

    // Position slide in non-loop mode
    const maxStart = Math.max(0, realSlidesCount - Math.ceil(perView));
    const targetPosition = Math.min(normalizedIndex, maxStart);
    swiper.slideTo(targetPosition, 0);

    // Re-enable loop
    swiper.loopCreate();
    swiper.update();

    // Fine-tune positioning
    setTimeout(() => {
      if (swiper.realIndex !== normalizedIndex) {
        swiper.slideToLoop(normalizedIndex, 300);
      }
    }, 100);
  }

  // Helper to check if loop setup is optimal for desktop
  validateLoopSetup() {
    const swiper = this.swiperElement;
    const perView = swiper.params.slidesPerView;
    const loopAdditionalSlides = swiper.params.loopAdditionalSlides || 0;
    const recommended = Math.ceil(perView) + 1;

    return {
      slidesPerView: perView,
      loopAdditionalSlides: loopAdditionalSlides,
      recommended: recommended,
      realSlides: this.getRealSlidesCount(swiper),
      totalSlides: swiper.slides.length,
      isOptimal: perView <= 1 || loopAdditionalSlides >= recommended
    };
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("realIndexChange", function () {
      if (_this.slidesToPreload) {
        _this.preloadNextSlides();
      }

      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });
  }

  destroy() {
    this.swiperElement.destroy();
  }
}

class Drawer {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.onDrawerClose = options["onDrawerClose"] || function () { };
    this.onDrawerOpen = options["onDrawerOpen"] || function () { };
    if (this.element.classList.contains("mobile-menu_wrapper")) {
      this.hamburger = document.body.querySelector("#hamburger-menu-icon");
    }

    this.isOpen = false;

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );
    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    responsive.addResizeListener(this, this.calculateMaxHeightListener);
    this.delegateBody.on("drawer:close-other", this._closeListener);
  }

  maxHeight() {
    document.documentElement.style.setProperty(
      `--${this.element.id}--height`,
      `${window.innerHeight}px`
    );
    if (this.element.getAttribute("id") == "cart-drawer") {
      const footer = this.element.querySelector(".cart-drawer__footer");
      let footerHeight = 0;
      if (footer !== null) {
        footerHeight = footer.offsetHeight;

        document.documentElement.style.setProperty(
          "--cart-drawer__footer-height",
          `${footerHeight}px`
        );
      }

      const headerEl = this.element.querySelector(".cart-drawer__header");
      let header = 0;
      if (headerEl) {
        header = headerEl.offsetHeight;
      }

      const itemWrapper = this.element.querySelector(".cart-items--Wrapper");

      if (itemWrapper !== null) {
        itemWrapper.style.height =
          window.innerHeight - footerHeight - header + "px";
      }
    } else if (this.element.id === "collection__filter-drawer") {
      const contentWrapper = this.element.querySelector(
        ".collection__filter-wrapper"
      );
      const header = this.element.querySelector(".Drawer--Header");
      const footer = this.element.querySelector(".Drawer--Footer");
      contentWrapper.style.height =
        this.element.offsetHeight -
        header.offsetHeight -
        footer.offsetHeight +
        "px";
    }
  }

  toggleDrawer() {
    event.preventDefault();
    this.isOpen ? this.closeDrawer() : this.openDrawer();
  }

  openDrawer() {
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );
    this.element.dispatchEvent(
      new CustomEvent("drawer:close-other", { bubbles: true })
    );

    if (this.element.classList.contains("mobile-menu_wrapper")) {
      this.hamburger.classList.add("is-active");
    }

    this.element.dispatchEvent(
      new CustomEvent(`${this.element.id}:open`, { bubbles: true })
    );

    if (this.isOpen) {
      return;
    }

    if (this.element.getAttribute("id") == "Drawer") {
      const closer = document.querySelector(".Drawer--Close");
      if (closer) {
        closer.style.display = "block";
      }
      this.element.dispatchEvent(
        new CustomEvent("sidebar-drawer:open", {
          bubbles: true,
        })
      );
    }
    this.element.removeAttribute("style");
    this.element.setAttribute("aria-expanded", "true");
    this.maxHeight();
    if (this.element.id === "collection__filter-drawer") {
      document
        .querySelector(".collection__page-overlay")
        .classList.add("is-visible");
      document
        .querySelector(".collection__page-overlay")
        .addEventListener("click", this._closeListener);
    } else if (this.element.id != "Drawer") {
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener("click", this._closeListener);
    }
    var focus = this.element.querySelector("[data-scrollable]");
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    document.body.classList.add("scrollLock");
    this.isOpen = true;
    this.onDrawerOpen();
    setTimeout(() => {
      trapFocus(this.element);
    }, 400);

    return false;
  }

  closeDrawer(event) {
    if (!this.isOpen) {
      return;
    }
    if (event) {
      event.preventDefault();
    }

    if (this.element.classList.contains("mobile-menu_wrapper")) {
      this.hamburger.classList.remove("is-active");
    }
    document.body.classList.remove("scrollLock");

    bodyScrollLock.clearAllBodyScrollLocks();

    this.element.setAttribute("aria-expanded", "false");
    this.element.dispatchEvent(
      new CustomEvent(`${this.element.id}:close`, { bubbles: true })
    );
    this.transitionEndHandler = (event) => this.handleTransitionEnd(event);
    this.element.addEventListener("transitionend", this.transitionEndHandler);

    if (this.element.id === "collection__filter-drawer") {
      document
        .querySelector(".collection__page-overlay")
        .classList.remove("is-visible");
      document
        .querySelector(".collection__page-overlay")
        .removeEventListener("click", this._closeListener);
    } else if (this.element.id != "Drawer") {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener("click", this._closeListener);
    }
    removeTrapFocus(this.element);
    this.isOpen = false;
    this.onDrawerClose();
  }

  handleTransitionEnd(event, target) {
    if (event.target !== this.element) return;
    this.element.removeEventListener(
      "transitionend",
      this.transitionEndHandler
    );
  }
}

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Initialize an array to store elements
              let elementsWithAnimation = [];

              // Select all elements with the data-animation attribute
              const animationNodes = node.querySelectorAll("[data-animation]");

              // Convert NodeList to Array and push elements into the array
              elementsWithAnimation.push(...animationNodes);

              // Check if the current node itself has the data-animation attribute
              if (node.hasAttribute("data-animation")) {
                elementsWithAnimation.push(node);
              }

              elementsWithAnimation.forEach((item, i) => {
                this.animateElement(item, this.integer);
                this.integer = this.integer + 1;
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    this.element.style.pointerEvents = "none";
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  // A function to animate a list of elements by scaling them out
  elementScaleOut(elements) {
    // Get the animation duration and delay from the theme settings
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;

    // Loop through each element in the list
    elements.forEach((element, index) => {
      // Check if the element has already been loaded
      if (element.hasAttribute("data-loaded")) {
        // If so, skip this element
        return;
      }

      // Mark the element as loaded to prevent duplicate animations
      element.setAttribute("data-loaded", true);

      // Define the animation keyframes
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];

      // Define the animation options
      const animationOptions = {
        duration: animationDuration,
        fill: "forwards",
      };

      // Schedule the animation with a delay based on the element's position in the list
      setTimeout(() => {
        element.animate(keyframes, animationOptions);
      }, animationDelay * index);
    });
  }

  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromBottomTranslate(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(45px)" },
          { transform: "translateY(0px)" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementClipRevealFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }

      // Define the clip path animation
      const clipReveal = [
        { clipPath: "inset(100% 0 0 0)", opacity: "0" },
        { clipPath: "inset(0 0 0 0)", opacity: "1" },
      ];

      // Animate the wrapper
      setTimeout(() => {
        item.animate(clipReveal, {
          duration: window.theme.animationDuration,
          fill: "forwards",
          easing: "cubic-bezier(0.23, 1, 0.32, 1)",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  animateElement(animatedItem, index) {
    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const integer = options.integer;
        const elements = [];

        // Iterate over the IntersectionObserverEntry objects in the results array.
        results.forEach((result) => {
          // Check if the target element is intersecting the root element or if its intersection ratio is greater than 0.
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // Add the target element to the elements array.
            elements.push(result.target);
            // Unobserve the target element.
            this.intersectionObserver[integer].unobserve(result.target);
          }
        });

        // If there are no elements to reveal, return.
        if (elements.length === 0) {
          return;
        }

        // An object that maps each animation type to the corresponding animation function.
        const animations = {
          elementFromTop: "elementFromTop",
          elementFromBottom: "elementFromBottom",
          elementFromBottomTranslate: "elementFromBottomTranslate",
          elementFromRight: "elementFromRight",
          elementFromLeft: "elementFromLeft",
          elementFromLeftBig: "elementFromLeftBig",
          elementFromRightBig: "elementFromRightBig",
          elementScaleIn: "elementScaleIn",
          elementScaleOut: "elementScaleOut",
          elementClipRevealFromRight: "elementClipRevealFromRight",
        };

        // Get the animation function corresponding to the type from the animations object.
        const animation = animations[options.type];
        // If the animation function exists, call it with the elements array.
        if (animation) {
          this[animation](elements);
        }
      },
      { threshold: 0.1 }
    );

    if (animatedItem.classList.contains("animatedContent")) {
      this.intersectionObserver[index].observe(animatedItem);
    }

    animatedItem.querySelectorAll(".animatedContent").forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

if (window.theme.enableAnimations && !document.getElementById('loader-element')) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation();
  });
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.toggleAddButton();
      this.input.dispatchEvent(this.changeEvent);
    }

    if (this.options["noVariants"] == "true") {
      this.toggleAddButton();
    }
  }

  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelector(".product-module__product-atc"),
      addButtonInner = addButton.querySelectorAll(".ButtonText"),
      quantityEl = document.querySelector(".product-module__quantity-input");
    if (quantityEl) {
      quantity = quantityEl.value;
    }
    if (window.variantInfo.show_icon) {
      var buySvg =
        '<svg class="mr-s" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M13.8888 6.66666V5.02777C13.8888 3.63841 13.1476 2.35458 11.9444 1.6599C10.7412 0.965215 9.25873 0.965215 8.0555 1.6599C6.85227 2.35458 6.11106 3.63841 6.11106 5.02777V8.91666C6.11106 9.22349 6.35979 9.47222 6.66661 9.47222C6.97344 9.47222 7.22217 9.22349 7.22217 8.91666V7.77777H11.6666V6.66666H7.22217V5.02777C7.22217 3.49365 8.46582 2.25 9.99995 2.25C11.5341 2.25 12.7777 3.49365 12.7777 5.02777V8.88889C12.7777 9.19571 13.0265 9.44444 13.3333 9.44444C13.6401 9.44444 13.8888 9.19571 13.8888 8.88889V7.77777H16.6666V17.7778H3.33328V7.77777H4.99995V6.66666H2.22217V17.8278C2.22217 18.4138 2.69724 18.8889 3.28328 18.8889H16.7166C17.3026 18.8889 17.7777 18.4138 17.7777 17.8278V6.66666H13.8888Z" fill="#272724" /> </svg>';
    } else {
      var buySvg = "";
    }

    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    addButton.removeAttribute("disabled");
    addButton.classList.remove("product-module__product-atc--sold-out");
    if (window.variantInfo.show_price) {
      var priceElement =
        "<span class='product-module__atc-price u-pb1'>&nbsp;&nbsp;-&nbsp;&nbsp;" +
        Shopify.formatMoney(
          this.options["price"] * quantity,
          window.theme.moneyFormat
        );
      +"</span>";
    } else {
      var priceElement = "";
    }

    addButtonInner.forEach((btn) => {
      btn.innerHTML = buySvg + window.variantStrings.addToCart + priceElement;
    });
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
  copped
) {
  if (!copped) this.countryEl = document.getElementById(country_domid);
  else this.countryEl = country_domid;
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  if (this.provinceEl) this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    if (this.provinceEl) {
      this.clearOptions(this.provinceEl);
      if (provinces && provinces.length == 0) {
        this.provinceContainer.style.display = "none";
      } else {
        for (var i = 0; i < provinces.length; i++) {
          var opt = document.createElement("option");
          opt.value = provinces[i][0];
          opt.innerHTML = provinces[i][1];
          this.provinceEl.appendChild(opt);
        }

        this.provinceContainer.style.display = "";
      }
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    // Parse options from the element's data-settings attribute
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    // Get the target countdown day from options (e.g., Monday = 1, etc.)
    const countdownDay = parseInt(this.options.countdownDays);

    // Get the current time in hours and minutes
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();

    if (!(this.options['startTime'] < currentHours && currentHours < this.options['endTime'])) {
      this.element.remove();
      return;
    }

    if (this.options['countdownType'] === 'every_day' && (todaysDay === 5 || todaysDay === 6)) {
      this.element.remove();
      return;
    }

    // Parse target time from the options (assuming '12:00' format)
    const [targetHours, targetMinutes] = this.options.countdownTime.split(':').map(Number);

    // Determine if the target time is before the current time
    const isBefore = targetHours < currentHours || (targetHours === currentHours && targetMinutes <= currentMinutes);

    // Calculate how many days ahead the target day is (handles weekly recurring countdowns)
    this.dayDifference = countdownDay - todaysDay;
    if (this.dayDifference < 0 || (this.dayDifference === 0 && isBefore)) {
      this.dayDifference += 7; // If the countdown day is earlier or passed today, add 7 days
    }

    // Get the target elements for displaying the countdown
    this.counters = this.element.querySelectorAll(".component-countDown");

    // Start the countdown, updating every second
    setInterval(this.countDown.bind(this), 1000);
  }

  // Countdown method that updates every second
  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();

    // Create the target date based on the dayDifference and target time
    let countDate = new Date();

    if (this.options['countdownType'] === 'reccuring') {
      // Add the day difference to move the target to the correct weekday

      countDate.setDate(countDate.getDate() + this.dayDifference);

      // Set the target time (hours and minutes) on that day
      const [targetHours, targetMinutes] = this.options.countdownTime.split(':').map(Number);
      countDate.setHours(targetHours, targetMinutes, 0, 0);

      // If the target time is the same as now (or has passed), move to the next occurrence of the day
      if (this.dayDifference === 0 && targetHours === currentHours && targetMinutes === currentMinutes) {
        // Move the target to the next week's occurrence (7 days later)
        countDate.setDate(countDate.getDate() + 7);
      }
    } else if (this.options['countdownType'] === 'to_date') {
      // For a "to_date" countdown, use the exact date and time from the options
      countDate = new Date(`${this.options.countdownDate} ${this.options.countdownTime}`);
    } else if (this.options['countdownType'] === 'every_day') {
      countDate.setDate(countDate.getDate() + 1);

      // Set the target time for the next day
      const [targetHours, targetMinutes] = this.options.countdownTime.split(':').map(Number);
      countDate.setHours(targetHours, targetMinutes, 0, 0);

      // If the target time is before the current time, adjust the countdown to the previous day
      if (targetHours > currentHours || (targetHours === currentHours && targetMinutes > currentMinutes)) {
        countDate.setDate(countDate.getDate() - 1);
      }
    }

    // Calculate the time difference between now and the target date
    const difference = countDate - dateNow;

    // Time constants in milliseconds
    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;

    // Calculate remaining days, hours, minutes, and seconds
    let textDays = Math.floor(difference / days);
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);

    // Format the hours, minutes, and seconds for display
    const formatHours = textHours < 10 ? `0${textHours}` : textHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    // Update the display with the countdown values
    if (textDays > 0) {
      this.counters.forEach(counter => counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`);
    } else {
      this.counters.forEach(counter => counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`);
    }
  }
}

// Define the custom element
customElements.define("countdown-element", Countdown);

class SectionCountdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    const countdownDay = parseInt(this.options.countdownDays);
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();

    if (!(this.options['startTime'] < currentHours && currentHours < this.options['endTime'])) {
      this.element.remove();
      return;
    }

    if (this.options['countdownType'] === 'every_day' && (todaysDay === 5 || todaysDay === 6)) {
      this.element.remove();
      return;
    }

    const [targetHours, targetMinutes] = this.options.countdownTime.split(':').map(Number);
    const isBefore = targetHours < currentHours || (targetHours === currentHours && targetMinutes <= currentMinutes);

    this.dayDifference = countdownDay - todaysDay;
    if (this.dayDifference < 0 || (this.dayDifference === 0 && isBefore)) {
      this.dayDifference += 7;
    }

    // Select specific counters
    this.daysEl = this.element.querySelector(".countdown-banner__countdown-item.days");
    this.hoursEl = this.element.querySelector(".countdown-banner__countdown-item.hours");
    this.minutesEl = this.element.querySelector(".countdown-banner__countdown-item.minutes");
    this.secondsEl = this.element.querySelector(".countdown-banner__countdown-item.seconds");

    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();

    let countDate = new Date();

    if (this.options['countdownType'] === 'reccuring') {
      countDate.setDate(countDate.getDate() + this.dayDifference);
      const [targetHours, targetMinutes] = this.options.countdownTime.split(':').map(Number);
      countDate.setHours(targetHours, targetMinutes, 0, 0);

      if (this.dayDifference === 0 && targetHours === currentHours && targetMinutes === currentMinutes) {
        countDate.setDate(countDate.getDate() + 7);
      }
    } else if (this.options['countdownType'] === 'to_date') {
      countDate = new Date(`${this.options.countdownDate} ${this.options.countdownTime}`);

    } else if (this.options['countdownType'] === 'every_day') {
      countDate.setDate(countDate.getDate() + 1);
      const [targetHours, targetMinutes] = this.options.countdownTime.split(':').map(Number);
      countDate.setHours(targetHours, targetMinutes, 0, 0);

      if (targetHours > currentHours || (targetHours === currentHours && targetMinutes > currentMinutes)) {
        countDate.setDate(countDate.getDate() - 1);
      }
    }

    const difference = countDate - dateNow;
    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;

    let textDays = Math.floor(difference / days);
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);

    const formatHours = textHours < 10 ? `0${textHours}` : textHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (this.daysEl) this.daysEl.innerText = textDays;
    if (this.hoursEl) this.hoursEl.innerText = formatHours;
    if (this.minutesEl) this.minutesEl.innerText = formatMinutes;
    if (this.secondsEl) this.secondsEl.innerText = formatSeconds;
  }
}

customElements.define("section-countdown-element", SectionCountdown);



class cartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.drawer = new Drawer(this.element, {
      onDrawerClose: () => {
        this.isOpen = false;
        this.recommendationsOpen = false;
        if (responsive.matchesBreakpoint("lap_and_up")) {
          this.onClose();
        }
        this.alreadyEntered = false;
      },
      onDrawerOpen: () => {
        this.isOpen = true;
        if (this.alreadyEntered == false) {
          this.onOpen();
        }
        this.alreadyEntered = true;
      },
    });
    this.loader = this.element.querySelector(".itemLoader");
    this.cartCount = document.querySelector(".cart-count");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.scrollableElement = this.element.querySelector(".cart-drawer__content");
    this.cartIds = false;
    this.isOpen = false;
    this.recommendationsOpen = false;
    this.recommendationLoading = false;
    this.recommendationsLoaded = false;
    this.alreadyEntered = false;
    this.first = true;
    this.isFirstSwipeMode = false;
    new AddToCart(this.element);

    this.bindEvents();
  }

  bindEvents() {
    if (window.theme.listener == "false") {
      this.onProductAddedListener = this.onProductAdded.bind(this);

      if (this.options["showRecommendations"]) {
        window.addEventListener("load", () => this.loadRecommendations(0));
      }

      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "quantity:changed",
        ".cart-item__quantity",
        this.updateItemQuantity.bind(this)
      );

      window.theme.listener = "true";
    }
  }

  attachDynamicHeightListeners() {
    const drawerEl = this.element;
    const contentEl = this.scrollableElement;
    const minHeight = this.minHeight;
    const maxHeight = this.minHeight + this.initialOffset;

    let state = 'collapsed';
    let activePointerId = null;
    let startY = null;
    let collapseCandidate = false;

    drawerEl.style.height = `${minHeight}px`;
    contentEl.classList.add('disable-pointer');

    if (this._drawerPointerCleanup) this._drawerPointerCleanup();

    const onPointerDown = (e) => {
      if (e.button !== 0 && e.pointerType === 'mouse') return;
      if (!drawerEl.contains(e.target)) return;

      e.preventDefault();

      activePointerId = e.pointerId;
      startY = e.clientY;

      drawerEl.setPointerCapture(activePointerId);
      drawerEl.style.transition = 'none';

      collapseCandidate = false;
      if (state === 'expanded') {
        if (!contentEl.contains(e.target) || contentEl.scrollTop === 0) {
          collapseCandidate = true;
        } else {
          drawerEl.releasePointerCapture(activePointerId);
          activePointerId = null;
          return;
        }
      }
    };

    const onPointerMove = (e) => {
      if (activePointerId === null || e.pointerId !== activePointerId) return;

      e.preventDefault();

      const deltaY = e.clientY - startY;

      if (state === 'collapsed') {
        if (deltaY < -10) {
          drawerEl.style.transition = "height 0.4s cubic-bezier(0.25,0.46,0.45,0.94)";
          drawerEl.style.height = `${maxHeight}px`;
          contentEl.classList.remove('disable-pointer');
          state = 'expanded';
          activePointerId = null;
          drawerEl.releasePointerCapture(e.pointerId);
        }
      } else if (state === 'expanded' && collapseCandidate) {
        if (deltaY > 10) {
          drawerEl.style.transition = "height 0.4s cubic-bezier(0.25,0.46,0.45,0.94)";
          drawerEl.style.height = `${minHeight}px`;
          contentEl.classList.add('disable-pointer');
          contentEl.scrollTop = 0;
          state = 'collapsed';
          activePointerId = null;
          drawerEl.releasePointerCapture(e.pointerId);
        }
      }
    };

    const onPointerUp = (e) => {
      if (activePointerId === null || e.pointerId !== activePointerId) return;

      if (drawerEl.hasPointerCapture(activePointerId)) {
        drawerEl.releasePointerCapture(activePointerId);
      }
      activePointerId = null;
      startY = null;
      collapseCandidate = false;
      drawerEl.style.transition = "";
    };

    const onPointerCancel = (e) => {
      if (activePointerId === null || e.pointerId !== activePointerId) return;
      if (drawerEl.hasPointerCapture(activePointerId)) {
        drawerEl.releasePointerCapture(activePointerId);
      }
      activePointerId = null;
      startY = null;
      collapseCandidate = false;
      drawerEl.style.transition = "";
    };

    drawerEl.addEventListener('pointerdown', onPointerDown);
    drawerEl.addEventListener('pointermove', onPointerMove);
    drawerEl.addEventListener('pointerup', onPointerUp);
    drawerEl.addEventListener('pointercancel', onPointerCancel);

    this._drawerPointerCleanup = () => {
      drawerEl.removeEventListener('pointerdown', onPointerDown);
      drawerEl.removeEventListener('pointermove', onPointerMove);
      drawerEl.removeEventListener('pointerup', onPointerUp);
      drawerEl.removeEventListener('pointercancel', onPointerCancel);
      this._drawerPointerCleanup = null;
    };
  }

  onOpen(deley) {
    document.documentElement.style.setProperty(
      "--cart-drawer__header-height",
      document.querySelector(".cart-drawer__header").offsetHeight + "px"
    );

    this.scrollableElement.classList.add('disable-pointer');
    if (this.first) {
      const drawerHeight = this.element.offsetHeight;
      this.initialOffset = window.innerHeight - drawerHeight;
      this.minHeight = drawerHeight;
      this.first = false;
      this.element.style.height = `${this.minHeight}px`;

      if (responsive.matchesBreakpoint('pocket')) {
        this.attachDynamicHeightListeners();
      }
    }

    if (this.options["showRecommendations"]) {
      this.loadRecommendations(deley);
    }
  }

  onClose() {
    this.recommendationContainer = document.querySelector(
      '.cart-drawer__desk-rec[aria-hidden="false"]'
    );
    if (!this.recommendationContainer) return;
    this.recommendationContainer.classList.remove("visible");
    this.transitionEndHandler = (event) =>
      this.handleTransitionEnd(this.recommendationContainer);
    this.recommendationContainer.addEventListener(
      "transitionend",
      this.transitionEndHandler
    );
    if (this.aboutToOpenRecommendaions) {
      clearTimeout(this.aboutToOpenRecommendaions);
    }
  }

  handleTransitionEnd(target) {
    target.setAttribute("aria-hidden", "true");
    target.style.display = "none";
    this.recommendationContainer.removeEventListener(
      "transitionend",
      this.transitionEndHandler
    );
  }

  async updateItemQuantity(event, target) {
    event.preventDefault();
    const cartItem = target.closest(".cart-item");
    const itemLoader = cartItem.querySelector(".itemLoader");
    itemLoader.classList.add("is-visible");

    let quantity;
    if (target.tagName === "INPUT") {
      quantity = Math.max(parseInt(target.value, 10) || 0, 0);
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"), 10);
    }

    const payload = {
      id: target.getAttribute("data-line-id"),
      quantity: quantity,
    };

    if (quantity === 0) {
      cartItem.classList.add("removing");
      const id = cartItem.dataset.id;
      if (this.cartIds) {
        this.cartIds = this.cartIds.filter((item) => item !== id);
      }
      const nextItem = cartItem.nextElementSibling;
      const height = cartItem.offsetHeight;
      document.documentElement.style.setProperty(
        "--repositioning_value",
        `${height}px`
      );
      setTimeout(() => {
        cartItem.remove();
        if (!nextItem) {
          return;
        }
        nextItem.classList.add("repo--top");
        setTimeout(() => {
          nextItem.classList.remove("repo--top");
        }, 350);
      }, 350);
    }

    try {
      const response = await fetch(
        `${window.routes.localeRootUrl}/cart/change.js`,
        {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      if (data.item_count == 0) {
        this.loader.classList.add("is-visible");
        this.renderCart(false, false);
      }
      if (quantity == 0) {
        if (this.options.showRecommendations) {
          if (data.items.length > 0) {
            this.options["productId"] = data.items[0].product_id;
          } else {
            this.options["productId"] = "";
          }

          if (data.item_count != 0) this.loadRecommendations();
          this.renderCart(false, false, false, null, true);
          return;
        }
      }
      this.renderCart(target.getAttribute("data-id"), true);
    } catch (error) {
      console.error("Failed to update item quantity:", error);
    }
  }

  onProductAdded() {
    let details = false;
    if (event.detail) {
      details = event.detail;
    }

    if (window.theme.cartCount == 0 && this.isOpen == true) {
      this.loader.classList.add("is-visible");
    }
    if (this.isOpen == false) {
      this.cartCount.classList.add("active");
    }

    this.renderCart(false, false, true, details).then(() => {
      if (this.element.hasAttribute('data-open-drawer')) {
        if (this.isOpen == false) {
          setTimeout(() => {
            this.isOpen = true;
            this.onOpen(true);
            this.alreadyEntered = true;
            this.drawer.openDrawer();
          }, 2900);
        }
      }
    });
  }

  renderCart(lineNumber, quantityChange, productAdd, productAddEvent, updateCount) {
    this.pageLoader.style.width = 100 + "%";
    var _this = this;
    return fetch(
      window.routes.localeRootUrl + "/?section_id=main-cart_drawer",
      {
        credentials: "same-origin",
        method: "GET",
      }
    ).then(function (content) {
      content.text().then(function (html) {
        _this.replaceContent(
          html,
          lineNumber,
          quantityChange,
          productAdd,
          productAddEvent,
          updateCount
        );
      });
    });
  }

  replaceContent(
    html,
    lineNumber,
    quantityChange,
    productAdd,
    productAddEvent,
    updateCount
  ) {
    if (!updateCount) {
      this.pageLoader.style.left = "unset";
      this.pageLoader.style.right = "0px";
      this.pageLoader.style.width = "0%";

      setTimeout(() => {
        this.pageLoader.style.left = "0px";
        this.pageLoader.style.right = "unset";
      }, 550);
    }

    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    const newOptions = JSON.parse(
      tempElement.querySelector("#cart-drawer").getAttribute("data-settings")
    );
    this.options = newOptions;

    if (!updateCount) {
      if (tempElement.querySelector("[data-ids]") != undefined) {
        this.cartIds = tempElement
          .querySelector("[data-ids]")
          .dataset.ids.split(",")
          .filter((item) => item !== "");
      }
    }

    const itemCount = newOptions.itemCount;
    this.cartCount.innerHTML = `${itemCount}`;
    if (this.isOpen == false) {
      setTimeout(() => {
        this.cartCount.classList.remove("active");
      }, 2500);
    }

    window.theme.cartCount = parseInt(itemCount);

    this.updateCartFooter(tempElement);

    if (updateCount) return;
    if (lineNumber) {
      this.updateCartItem(lineNumber, tempElement);
    } else if (productAdd && itemCount > 1) {
      this.addContent(tempElement, productAddEvent);
    } else {
      this.replaceCartContent(tempElement);
    }

    setTimeout(() => {
      if (
        this.options.showRecommendations &&
        !quantityChange &&
        this.isOpen == true
      ) {
        this.loadRecommendations();
      }
      const focusElement = this.element.querySelector("[data-scrollable]");
      if (this.element.hasAttribute('data-open-drawer')) {
        bodyScrollLock.disableBodyScroll(focusElement, bodyScrollLockOptions);
      }
      this.drawer.maxHeight();
    }, 200);
  }

  updateCartItem(lineNumber, tempElement) {
    const cartItemParent = this.element.querySelector(`#${lineNumber}`);
    const newCartItemInfo = tempElement.querySelector(
      `#${lineNumber} .cart-item__info`
    );

    if (!cartItemParent) {
      this.element
        .querySelector(".itemLoader")
        .classList.remove("is-visible");
    } else {
      cartItemParent
        .querySelector(".itemLoader")
        .classList.remove("is-visible");
    }

    if (newCartItemInfo) {
      cartItemParent.replaceChild(
        newCartItemInfo,
        cartItemParent.querySelector(".cart-item__info")
      );
    } else if (cartItemParent) {
      this.removeCartItem(cartItemParent);
    }
  }

  addContent(tempElement, productAddEvent) {
    if (this.isOpen) {
      this.element.querySelector(".cart-drawer__content").scrollTop = 0;
    }
    const itemToAdd = tempElement.querySelector(
      `#cart-item__${productAddEvent.variant}`
    );
    const cartWrapper = this.element.querySelector(".cart-drawer__items");
    const firstItem = cartWrapper.firstElementChild;
    if (cartWrapper.querySelector(`#cart-item__${productAddEvent.variant}`)) {
      this.updateCartItem(`cart-item__${productAddEvent.variant}`, tempElement);
    } else {
      const height = this.calculateDetachedElement(itemToAdd);
      document.documentElement.style.setProperty(
        "--repositioning_value",
        `${height}px`
      );
      firstItem.classList.add("repo--bottom");
      this.loader.classList.remove("is-visible");
      setTimeout(() => {
        cartWrapper.prepend(itemToAdd);
        itemToAdd.classList.add("repo--adding");
        firstItem.classList.remove("repo--bottom");

        setTimeout(() => {
          itemToAdd.classList.remove("repo--adding");
        }, 350);
      }, 350);
    }
  }

  calculateDetachedElement(element) {
    const detachedContainer = document.createElement("div");
    detachedContainer.style.position = "absolute";
    detachedContainer.style.visibility = "hidden";
    detachedContainer.style.height = "auto";
    detachedContainer.style.width = "auto";
    detachedContainer.style.top = "-9999px";

    detachedContainer.appendChild(element);
    this.element.appendChild(detachedContainer);

    const newItemHeight = element.offsetHeight + 16;
    this.element.removeChild(detachedContainer);

    return newItemHeight;
  }

  updateCartFooter(tempElement) {
    const itemCount = this.options.itemCount;
    if (itemCount > 0) {
      const footerParent = this.element.querySelector(".cart-drawer__footer");
      const newFooterTotals = tempElement.querySelector(
        ".cart_drawer__footer-totals"
      );
      if (!footerParent || !newFooterTotals) return;
      footerParent.replaceChild(
        newFooterTotals,
        footerParent.querySelector(".cart_drawer__footer-totals")
      );

      const newShippingBar = tempElement.querySelector(
        ".cart-drawer__shipping-progress-bar"
      );
      if (newShippingBar) {
        const currentShippingBar = this.element.querySelector(
          ".cart-drawer__shipping-progress-bar"
        );
        if (currentShippingBar) {
          let percent = newShippingBar.dataset.percent;
          if (percent > 100) {
            percent = 100;
          }
          currentShippingBar.dataset.percent = percent;
          currentShippingBar.style.width = `${percent}%`;
          if (percent == 100) {
            currentShippingBar.classList.add("done");
            currentShippingBar.classList.remove("active");
          } else {
            currentShippingBar.classList.remove("done");
            currentShippingBar.classList.add("active");
          }

          this.element.querySelector(".cart-drawer__shipping-text").innerHTML =
            tempElement.querySelector(".cart-drawer__shipping-text").innerHTML;
        } else {
          const headerParent = this.element.querySelector(
            ".cart-drawer__header"
          );
          headerParent.appendChild(
            tempElement.querySelector(".cart-drawer__shipping")
          );
        }
      }
    } else {
      this.clearCartFooter(tempElement);
    }
  }

  clearCartFooter(tempElement) {
    if (!tempElement.querySelector(".cart-drawer__wrapper")) return;
    if (this.element.querySelector(".cart-drawer__footer")) {
      this.element
        .querySelector(".cart-drawer__footer")
        .classList.add("removing");
    }

    const wrapperParent = this.element.querySelector(".cart-drawer__wrapper");
    if (wrapperParent) {
      wrapperParent.innerHTML = tempElement.querySelector(
        ".cart-drawer__wrapper"
      ).innerHTML;
    }
  }

  replaceCartContent(tempElement) {
    const cartWrapperParent = this.element.querySelector(
      ".cart-drawer__wrapper"
    ).parentNode;
    const currentScrollPosition = this.element.querySelector(
      ".cart-drawer__content"
    ).scrollTop;

    cartWrapperParent.replaceChild(
      tempElement.querySelector(".cart-drawer__wrapper"),
      this.element.querySelector(".cart-drawer__wrapper")
    );
    setTimeout(() => {
      this.loader.classList.remove("is-visible");
    }, 200);
    this.element.querySelector(".cart-drawer__content").scrollTop =
      currentScrollPosition;
  }

  loadRecommendations(deley) {
    if (this.recommendationLoading == true || this.isOpen == false) return;
    this.recommendationLoading = true;
    let recommendationsContainer = this.element.querySelector(
      ".cart-drawer__recommendations"
    );
    if (!recommendationsContainer) return;
    const productId = this.options["productId"];
    const baseUrl = window.routes.localeRootUrl;
    let url;

    if (!productId) {
      url = "?section_id=helper-recommendations";
    } else {
      let limit = this.element.getAttribute('product-limit');
      url = `${baseUrl}/recommendations/products?section_id=helper-recommendations&product_id=${productId}&l${limit}`;
    }

    if (responsive.matchesBreakpoint("lap_and_up")) {
      recommendationsContainer = document.querySelector(
        ".cart-drawer__desk-rec-items"
      );
    }
    if (!recommendationsContainer) return;

    recommendationsContainer.classList.remove("transition--done");
    if (this.recommendationsOpen == true) {
      recommendationsContainer.classList.add("transition");
    }

    return fetch(url)
      .then((response) => response.text())
      .then((content) => {
        this.recommendationLoading = false;
        const container = document.createElement("div");
        container.innerHTML = content;

        let recommendedIds = null;
        if (container.querySelector(".cart-drawer__rec-item")) {
          recommendedIds = [
            ...container.querySelectorAll(".cart-drawer__rec-item"),
          ].map((item) => item.dataset.id);
        }
        if (!this.cartIds) {
          if (recommendationsContainer.dataset.ids) {
            this.cartIds = recommendationsContainer.dataset.ids
              .split(",")
              .filter((item) => item !== "");
          }
        }

        if (this.cartIds) {
          const hasCommonItem = this.cartIds.some((item) =>
            recommendedIds.includes(item)
          );
          if (hasCommonItem) {
            return;
          }
        }

        if (responsive.matchesBreakpoint("lap_and_up")) {
          if (!this.isOpen) return;
          this.renderDesktopRecommendations(
            container,
            recommendationsContainer,
            false
          );
          return;
        }

        let recommendationsHTML = container.querySelector(
          ".cart-drawer__upsell"
        )?.innerHTML;
        if (recommendationsHTML) {
          recommendationsContainer.innerHTML = recommendationsHTML;
          this.initializeSwiper();
          new AddToCart(this.element);
          recommendationsContainer.setAttribute('data-animation', 'elementClipRevealFromRight');
          new RevolutionAnimation(recommendationsContainer, true).elementClipRevealFromRight([recommendationsContainer]);
          if (typeof window['yotpo'] !== 'undefined') {
            window['yotpo'].initWidgets();
          } else {
            yotpoWidgetsContainer.initWidgets();
          }
        }
      })
      .catch((error) => {
        console.error("Failed to load recommendations:", error);
      });
  }

  handleTransitionRec(target, container) {
    if (event.propertyName !== "transform") return;
    target.setAttribute("aria-hidden", "true");
    target.style.display = "none";
    container.classList.remove("transition");
    this.recommendationsOpen = false;
    this.el.removeEventListener("transitionend", this.transitionRecEnd);
  }

  renderDesktopRecommendations(container, recommendationsContainer, deley) {
    if (!recommendationsContainer) {
      const newNode = document
        .querySelector("#cart-drawer__recommendations-template")
        .content.firstElementChild.cloneNode(true);
      document.querySelector("#cart-drawer__recommendations-template").remove();
      this.element.insertAdjacentElement("afterend", newNode);
      recommendationsContainer = document.querySelector(
        ".cart-drawer__desk-rec-items"
      );
    }

    const items = container.querySelectorAll(".cart-drawer__rec-item");
    const swiperWrapper = recommendationsContainer.querySelector('.swiper-wrapper')
    swiperWrapper.innerHTML = "";

    items.forEach(item => {
      swiperWrapper.appendChild(item);
    });

    const swiperElement = recommendationsContainer.querySelector('.swiper');
    new RevolutionSwiper(swiperElement);
    new AddToCart(recommendationsContainer);

    if (items.length == 0) {
      this.el = recommendationsContainer.parentElement;
      this.el.classList.remove("visible");
      this.transitionRecEnd = (event) =>
        this.handleTransitionRec(this.el, recommendationsContainer);
      this.el.addEventListener("transitionend", this.transitionRecEnd);
      return;
    }

    this.aboutToOpenRecommendaions = setTimeout(
      () => {
        if (!this.isOpen) return;

        recommendationsContainer.parentElement.style.display = "block";
        recommendationsContainer.parentElement.setAttribute(
          "aria-hidden",
          "false"
        );
        recommendationsContainer.parentElement.offsetHeight;
        if (typeof window['yotpo'] !== 'undefined') {
          window['yotpo'].initWidgets();
        } else {
          yotpoWidgetsContainer.initWidgets();
        }
        requestAnimationFrame(() => {
          if (this.recommendationsOpen == false) {
            setTimeout(() => {
              recommendationsContainer.parentElement.classList.add("visible");
              this.recommendationsOpen = true;
            }, 25);
          } else {
            setTimeout(() => {
              recommendationsContainer.classList.remove("transition");
              recommendationsContainer.classList.add("transition--done");
            }, 250);
          }
        });
      },
      deley ? 2500 : 0
    );
  }

  initializeSwiper() {
    new Swiper(".helper-recomm-swiper", {
      slidesPerView: 1.868,
      spaceBetween: 8,
      allowTouchMove: true,
      mousewheel: {
        forceToAxis: true,
      },
      nested: true,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
    });
  }
}

customElements.define("cart-drawer", cartDrawer);

class FeaturedCollectionSection extends HTMLElement {
  constructor() {
    super();
    var _this = this;
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".swiper");
    this.swiperBtnNext = this.element.querySelector(
      ".featured-collection__swiper-btn--next"
    );
    this.swiperBtnPrev = this.element.querySelector(
      ".featured-collection__swiper-btn--prev"
    );
    const swiperInstance = new RevolutionSwiper(this.carouselElement);
    this.currentSwiper = swiperInstance;
    window.addEventListener("DOMContentLoaded", this.initializeHeadingButtons.bind(this));
    window.addEventListener("load", this.initializeHeadingButtons.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=change-tab]",
      this.handleHeadingButtonClick.bind(this)
    );
  }


  //Add active class to first heading button, display first block
  initializeHeadingButtons() {
    const buttons = this.querySelectorAll(
      ".featured-collection__heading-button"
    );
    const blocks = this.querySelectorAll(".featured-collection__content-block");
    const dynamicSubtext = this.element.querySelector(
      ".featured-collection__dynamic-subtext"
    );
    const dynamicBtnCollectionLink = this.element.querySelector(
      ".collection-dynamic-btn"
    );
    const parentElement = this.element.querySelector(
      ".featured-collection__heading-buttons"
    );

    if (buttons.length > 0) {
      buttons[0].classList.add("featured-collection__heading-button--active");
      const activeBlockName = buttons[0].textContent.trim();
      dynamicSubtext.textContent = activeBlockName;
      const buttonAnimationDiv = this.element.querySelector(
        ".featured-collection-button-overlay--animation"
      );

      //Calculate button container height and adjust animation in case of multiline buttons
      const computedStyle = window.getComputedStyle(parentElement);
      const paddingTop = parseFloat(computedStyle.paddingTop);
      const paddingBottom = parseFloat(computedStyle.paddingBottom);
      const totalHeight = parentElement.offsetHeight;
      const heightWithoutPadding = totalHeight - paddingTop - paddingBottom;
      const isMultiLine = heightWithoutPadding > buttons[0].offsetHeight;

      if (isMultiLine) {
        parentElement.classList.add("multi-line-btn__container");
      } else {
        parentElement.classList.remove("multi-line-btn__container");
      }

      const buttonWithPadding = buttons[0].offsetWidth;
      const buttonLeft = buttons[0].offsetLeft;
      const buttonHeight = buttons[0].offsetHeight;
      const buttonTop = buttons[0].offsetTop;
      buttonAnimationDiv.style.width = `${buttonWithPadding}px`;
      buttonAnimationDiv.style.height = `${buttonHeight}px`;
      buttonAnimationDiv.style.transform = `translate(${buttonLeft}px, ${buttonTop}px)`;
      buttons[0].classList.add("featured-collection__heading-button--active");
    }
    blocks.forEach((block, index) => {
      if (index === 0) {
        block.classList.add("featured-collection__content-block--active");
        const collectionUrl = block.getAttribute("data-collection-url");
        if (dynamicBtnCollectionLink) {
          dynamicBtnCollectionLink.href = collectionUrl;
        }
      }
    });
  }

  //Display block depending on targetId from heading btn, initialize or destroy swiper instance on heading button click, add active class to first product button in target block
  handleHeadingButtonClick(event) {
    const currentHeadingButton = event.target;
    const targetId = currentHeadingButton.getAttribute("data-target");
    const buttonAnimationDiv = this.element.querySelector(
      ".featured-collection-button-overlay--animation"
    );
    const blocks = this.querySelectorAll(".featured-collection__content-block");
    const dynamicSubtext = this.element.querySelector(
      ".featured-collection__dynamic-subtext"
    );
    const dynamicBtnCollectionLink = this.element.querySelector(
      ".collection-dynamic-btn"
    );

    blocks.forEach((block) => {
      block.classList.remove("featured-collection__content-block--active");
      const slides = block.querySelectorAll(".swiper-slide");
      slides.forEach((slide) => {
        slide.classList.remove("animated");
      });
    });

    const targetBlock = this.querySelector(`#${targetId}`);
    if (targetBlock) {
      if (this.currentSwiper) {
        this.currentSwiper.swiperElement.destroy(true, false);
      }
      targetBlock.classList.add("featured-collection__content-block--active");

      const targetSlides = targetBlock.querySelectorAll(".swiper-slide");
      targetSlides.forEach((slide) => {
        slide.classList.add("animated");
      });

      const collectionUrl = targetBlock.getAttribute("data-collection-url");
      if (dynamicBtnCollectionLink) {
        dynamicBtnCollectionLink.href = collectionUrl;
      }

      const activeBlockName = currentHeadingButton.textContent.trim();
      dynamicSubtext.textContent = activeBlockName;

      const allHeadingButtons = this.querySelectorAll(
        ".featured-collection__heading-button"
      );
      allHeadingButtons.forEach((btn) =>
        btn.classList.remove("featured-collection__heading-button--active")
      );
      setTimeout(function () {
        currentHeadingButton.classList.add(
          "featured-collection__heading-button--active"
        );
      }, 50);

      const buttonWidth = currentHeadingButton.offsetWidth;
      const buttonLeft = currentHeadingButton.offsetLeft;
      const buttonHeight = currentHeadingButton.offsetHeight;
      const buttonTop = currentHeadingButton.offsetTop;
      buttonAnimationDiv.style.width = `${buttonWidth}px`;
      buttonAnimationDiv.style.height = `${buttonHeight}px`;
      buttonAnimationDiv.style.transform = `translate(${buttonLeft}px, ${buttonTop}px)`;

      this.carouselElement = targetBlock.querySelector(".swiper");
      const swiperInstance = new RevolutionSwiper(this.carouselElement);
      this.currentSwiper = swiperInstance;
    }
  }
}
customElements.define("featured-collection", FeaturedCollectionSection);

class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}
customElements.define("slider-text", SliderTextSection);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.carouselElement = this.element.querySelector("[data-swiper-settings]");
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.delegateElement = new Delegate(this.element);
    if (this.options["numberOfSlides"] > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.onImagesReady = this.createObserver.bind(this);
      this.element.addEventListener("swiper:slide-changed", this.onImagesReady);
      this.createObserver();
    } else {
      this.createObserver();
    }

    this.section = document.querySelector(".section-heading__subheading");
    if (this.section) {
      this.delegateElement = new Delegate(this.element);
      this.bindEvents();
    }
  }

  bindEvents() {
    this.delegateElement.on('click', '[data-action="scroll-to"]', this.scrollTo.bind(this));
  }

  scrollTo(e) {
    e.preventDefault();

    this.section.scrollIntoView({ behavior: "smooth" });
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });

    const target = this.element;
    this.observer.observe(target);
  }

  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (_this.options["numberOfSlides"] > 1) {
          _this.changeImageQuality();
        } else {
          _this.changeImageQuality(true);
        }
        _this.observer.unobserve(_this);
      }
    });
  }
  changeImageQuality(singleItem) {
    // Get the current breakpoint.
    const breakpoint = responsive.getCurrentBreakpoint();

    let imageContainers;
    // Determine which element(s) to search for based on the singleItem parameter.
    if (singleItem) {
      imageContainers = Array.from(
        this.element.querySelectorAll(".banner-image_container-swap")
      );
    } else {
      const currentIndex = this.carousel.swiperElement.activeIndex;
      const cellElement = this.carousel.swiperElement.slides[currentIndex];
      imageContainers = Array.from(
        cellElement.querySelectorAll(".banner-image_container-swap")
      );
    }

    // If no image containers are found, return.
    if (imageContainers.length === 0) {
      return;
    }
    // Determine which image to reveal based on the current breakpoint.
    let imageToReveal;
    if (breakpoint === "pocket") {
      imageToReveal = imageContainers[0].querySelector(".banner-image");
    } else {
      if (imageContainers.length == 2) {
        imageToReveal = imageContainers[1].querySelector(".banner-image");
      } else {
        imageToReveal = imageContainers[0].querySelector(".banner-image");
      }
    }

    // If the image to reveal is not found or has already been loaded, return.
    if (!imageToReveal || imageToReveal.dataset.loadedImage === "true") {
      return;
    }
    // Replace the image URL with a higher quality version.
    if (!imageToReveal.dataset.src) return;
    const replaceUrl = imageToReveal.dataset.src.replace(
      "{width}x",
      "width=2600"
    );
    imageToReveal.src = replaceUrl;
    imageToReveal.dataset.loadedImage = "true";
  }
}
customElements.define("banner-hero", Banner);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.scrollableElement = this.element.querySelector("[data-scrollable]");

    if (this.options.sticky) {
      this.toggleSticky();
    }
    document.documentElement.style.setProperty(
      "--header-height-fixed",
      document.querySelector("#header").offsetHeight + "px"
    );

    this.updateVisibleHeight();
    this.bindEvents();
  }

  updateVisibleHeight() {
    setTimeout(() => {
      const rect = this.element.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // Calculate the visible height
      let visibleHeight =
        Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

      // Ensure the visibleHeight is never negative
      visibleHeight = Math.max(visibleHeight, 0);
      // Update the height of header with the visible height
      document.documentElement.style.setProperty(
        "--header-dynamic-height",
        `${visibleHeight}px`
      );

      document.documentElement.style.setProperty(
        "--header-height-fixed",
        document.querySelector("#header").offsetHeight + "px"
      );
    }, 250);
  }

  toggleSticky() {
    this.element.parentElement.classList.add("header--Sticky");
  }

  bindEvents() {
    this.closeMenuListener = this.closeMenu.bind(this);
    this.openMenuListener = this.openMenu.bind(this);
    this.toggleColorListener = this.toggleColor.bind(this);
    this.hoverLinkListener = this.showCollectionImage.bind(this);
    this.LinkListener = this.showDefaultImage.bind(this);

    if (this.options.sticky) {
      this.toggleTopBarListener = this.toggleTopBar.bind(this);
    }

    if (new Responsive().matchesBreakpoint("desktop")) {
      window.addEventListener("scroll", this.toggleColorListener);
      window.addEventListener("scroll", this.toggleTopBarListener);
    }
    this.delegateElement.on(
      "mouseenter",
      ".main-menu_multiple-items_sub-link",
      this.hoverLinkListener,
      true
    );
    this.delegateElement.on(
      "mouseleave",
      ".main-menu_multiple-items_sub-link",
      this.LinkListener,
      true
    );
    this.delegateElement.on(
      "mouseenter",
      "[aria-hasMenu='true']",
      this.openMenuListener,
      true
    );
    this.delegateElement.on(
      "click",
      ".header-link_list",
      this.closeMenuListener,
      true
    );
    this.delegateElement.on(
      "focusin",
      "[aria-hasMenu='true']",
      this.openMenuListener,
      true
    );
    this.delegateElement.on(
      "mouseleave",
      "[aria-submenu]",
      this.closeMenuListener,
      true
    );
    this.delegateElement.on(
      "mouseenter",
      "[aria-singlemenu]",
      this.closeMenuListener,
      true
    );
    this.delegateElement.on(
      "focusin",
      "[aria-singleMenu], .mainLinks",
      this.closeMenuListener,
      true
    );

    this.delegateBody.on("menu:close", this.closeMenuListener);

    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    window.addEventListener("resize", this.updateVisibleHeight.bind(this));
  }

  toggleTopBar() {
    let current = window.scrollY;
    let annBar = document.querySelector(".announcementBar");
    let element_height = this.element.offsetHeight;

    if ((element_height + annBar?.offsetHeight) * 2 < current) {
      this.element.parentElement.classList.add("header--fixed-top-bar");
    }

    if (current <= annBar?.offsetHeight) {
      this.element.parentElement.classList.remove("header--fixed-top-bar");
    }

    if (
      this.prevOffset < current &&
      current >= annBar?.offsetHeight + this.element.offsetHeight
    ) {
      if (responsive.matchesBreakpoint("lap_and_up")) {
        this.element.parentElement.classList.add("header--hide");
        document.documentElement.style.setProperty(
          "--header-dynamic-height",
          `0px`
        );
      }
    } else {
      if (responsive.matchesBreakpoint("lap_and_up")) {
        this.element.parentElement.classList.remove("header--hide");
      }
      this.updateVisibleHeight();
    }

    this.prevOffset = current;
  }

  updateMenuPosition() {
    document.documentElement.style.setProperty(
      "--submenu-position",

      `${document.querySelector("#header").offsetHeight}px`
    );
  }

  openMenu(event, target) {
    // Dispatch a custom event to indicate that the menu is being opened.

    this.element.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));

    // If the event is a mouseenter event and the target is not the same as the event target, return.
    if (event.type === "mouseenter" && target !== event.target) {
      return;
    }

    // Update the position of the menu and change the ARIA expanded attribute.
    this.updateMenuPosition(target);

    target.setAttribute("aria-expanded", "true");

    this.listener = target.parentElement.querySelector(
      ".desktop-menu_dropdown"
    );
    this.pointerTarget = target.closest(".header-links");
    this.listener.addEventListener(
      "animationstart",
      this.animationStartListener
    );
    this.listener.addEventListener("animationend", this.animationStartListener);

    // Close any siblings of the target element.
    const siblings = Array.from(target.parentElement.children).filter(
      (child) =>
        child !== target && child.getAttribute("aria-expanded") === "true"
    );
    siblings.forEach((item) => item.setAttribute("aria-expanded", "false"));

    // Disable body scroll on the scrollable element inside the menu.
    bodyScrollLock.disableBodyScroll(
      this.scrollableElement,
      bodyScrollLockOptions
    );
  }

  closeMenu(event, target) {
    if (event.type === "mouseleave" && target !== event.target) {
      return;
    }

    const openElement = this.element.querySelector('[aria-expanded="true"]');
    if (!openElement) return;
    this.listener = openElement.querySelector(".desktop-menu_dropdown");
    if (!this.listener) return;
    this.pointerTarget = openElement;
    this.listener.addEventListener(
      "animationstart",
      this.animationStartListener
    );
    this.listener.addEventListener("animationend", this.animationStartListener);

    openElement.setAttribute("aria-expanded", "false");

    if (
      !event.target.classList.contains("searchItem") &&
      !event.target.classList.contains("RevolutionSelectbox--Title")
    ) {
      setTimeout(() => {
        this.toggleColor();
      }, 600);
    }

    bodyScrollLock.enableBodyScroll(this.scrollableElement);
  }

  toggleColor() {
    const currentScrollPosition = window.pageYOffset;
    // Only add 'Header--Scrolled' if scrolling up and past a certain point
    if (
      currentScrollPosition < this.lastScrollPosition &&
      currentScrollPosition > 125
    ) {
      this.element.classList.add("Header--Scrolled");
    } else {
      this.element.classList.remove("Header--Scrolled");
    }

    // Update the last scroll position to current for the next event
    this.lastScrollPosition = currentScrollPosition;
  }

  showCollectionImage(event, target) {
    let productImage = target.closest('.header-links').querySelector(".main-img_wrapper");

    let menuHoverImage = target.querySelector(".menu-hover-image");
    if (menuHoverImage) {
      clearTimeout(this.setToDefault);
      productImage.style.opacity = "0";
      productImage.srcset = menuHoverImage.srcset;
      productImage.style.opacity = "1";
    }
  }

  showDefaultImage(event, target) {
    clearTimeout(this.setToDefault);
    let productImage = target.closest('.header-links').querySelector(".main-img_wrapper");
    let productimgSrc = productImage.getAttribute("data-src");
    this.setToDefault = setTimeout(() => {
      productImage.style.opacity = "0";
      productImage.srcset = productimgSrc;
      productImage.style.opacity = "1";
    }, 350);
  }
}
customElements.define("header-component", Header);


// {
//   "video_type": null,
//   "muted": true,
//   "controls": false,
//   "viewport": true,
//   "loop": true,
//   "videom": "https://www.youtube.com/watch?v=67wjpYXC-HA",
//   "videod": "https://www.youtube.com/watch?v=67wjpYXC-HA",
//   "id": "video_PKfk3i",
//   "aspect_mob": "1/1",
//   "aspect_desk": "1/1"
// }


class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.SidebarMenu = new Drawer(this.element);
    this.delegateElement = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".mobile-menu-swiper");
    this.carouselThumbs = this.element.querySelector(".mobile-menu_links-swiper");
    this.pageOverlayElement = this.element.querySelector(".sectionOverlay");
    this.carousel = new RevolutionSwiper(this.carouselElement, this.carouselThumbs);

    this.drawerWrapper = this.element.querySelector('.Drawer--Wrapper');
    this.handle = this.element.querySelector('.drawer-handle__wrapper');

    const originalClose = this.SidebarMenu.closeDrawer.bind(this.SidebarMenu);
    this.SidebarMenu.closeDrawer = () => {
      originalClose();
      this.pageOverlayElement.classList.remove("is-visible");
      setTimeout(() => {
        this.drawerWrapper.style.transform = '';
      }, 500);
    };

    this.initDragHandle();
    this.bindEvents();
  }

  bindEvents() {
    this.onDrawerOpen = this.initializeHeadingButtons.bind(this);
    document.addEventListener("sidebar-drawer:open", this.onDrawerOpen);

    this.delegateElement.on("swiper:slide-changed", this.onSlideChange.bind(this));

    this.delegateElement.on("click", '[data-action="see-all"]', this.showMore.bind(this));

    if (this.pageOverlayElement) {
      this.pageOverlayElement.addEventListener("click", () => {
        this.SidebarMenu.closeDrawer();
        this.pageOverlayElement.classList.remove("is-visible");
      });
    }
  }

  initDragHandle() {
    let startY = 0, currentY = 0;
    const threshold = 80, wrap = this.drawerWrapper;
    if (!this.handle) { return; }
    this.handle.addEventListener('pointerdown', e => {
      startY = e.clientY;
      this.handle.setPointerCapture(e.pointerId);
      wrap.style.transition = 'none';
    });

    this.handle.addEventListener('pointermove', e => {
      if (!startY) return;
      currentY = e.clientY;
      const dy = currentY - startY;
      if (dy > 0) wrap.style.transform = `translateY(${dy}px)`;
    });

    this.handle.addEventListener('pointerup', e => {
      this.handle.releasePointerCapture(e.pointerId);
      wrap.style.transition = '';

      if (currentY - startY > threshold) {
        this.SidebarMenu.closeDrawer();
      } else {
        wrap.style.transform = '';
      }

      startY = currentY = 0;
    });
  }

  onSlideChange() {
    this.handleHeadingButtonClick();
  }

  initializeHeadingButtons() {
    const activeTab = this.element.querySelector('.swiper-slide-thumb-active');
    const animDiv = this.element.querySelector('.mobile-menu_tabs-swiper-overlay_animation');
    const btnRect = activeTab.getBoundingClientRect();
    const tabsRect = activeTab.parentElement.getBoundingClientRect();

    animDiv.style.width = `${btnRect.width}px`;
    animDiv.style.transform = `translateX(${btnRect.left - tabsRect.left}px)`;

    if (this.pageOverlayElement) {
      this.pageOverlayElement.classList.add("is-visible");
    }
  }

  handleHeadingButtonClick() {
    const idx = this.carouselElement.swiper.activeIndex;
    const target = this.element.querySelector(`.swiper-slide[data-index="${idx}"]`);
    const animDiv = this.element.querySelector('.mobile-menu_tabs-swiper-overlay_animation');
    const btnRect = target.getBoundingClientRect();
    const tabsRect = target.parentElement.getBoundingClientRect();

    animDiv.style.width = `${btnRect.width}px`;
    animDiv.style.transform = `translateX(${btnRect.left - tabsRect.left}px)`;
  }

  showMore(event, target) {
    target.classList.toggle("active");
    const count = window.numberCount || 0;

    if (target.classList.contains("active")) {
      target.textContent = "See Less";
      target.closest(".sub-menu_wrapper").querySelector(".additional-links").setAttribute("aria-expanded", "true");
      new RevolutionAnimation(target.closest(".sub-menu_wrapper").querySelector(".additional-links"), "true").slideDown();
    } else {
      target.textContent = `See all (${count} more)`;
      target.closest(".sub-menu_wrapper").querySelector(".additional-links").setAttribute("aria-expanded", "false");
      new RevolutionAnimation(target.closest(".sub-menu_wrapper").querySelector(".additional-links"), "true").slideUp();
    }
  }
}

customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {
      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
new Transition();

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;

    if (this.options["using_fade"] == "fade") {
      if (
        this.element.dataset.position == 0 ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-active") ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-duplicate-active")
      ) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const isMobile = responsive.matchesBreakpoint("pocket");

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );

        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }
    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"
          ? "video/vimeo"
          : "video/mp4";

    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: this.options["controls"],
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      controlBar: {
        children: [
          "playToggle",
          "progressControl",
          "currentTimeDisplay",
          "timeDivider",
          "durationDisplay",
          "CustomControlSpacer",
          "VolumePanel",
          "fullscreenToggle",
        ],
      },

      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      if (_this.trueObserver == false && _this.options["viewport"]) {
        _this.createObserver();
      }
    });

    if (this.options["muted"] && host == "vimeo") {
      this.videoPlayer.on("play", function () {
        _this.videoPlayer.muted("true");
      });
    }

    if (this.options["controls"]) {
      if (host == "html5") {
        this.videoPlayer.on("touchstart", function () {
          if (event.target.closest(".vjs-control-bar")) {
            return;
          }

          if (_this.videoPlayer.paused()) {
            _this.videoPlayer.play();
          } else {
            _this.videoPlayer.pause();
          }
        });
      }
      if (host == "html5") return;
      this.videoPlayer.on("click", function () {
        if (event.target.closest(".vjs-control-bar")) {
          return;
        }

        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });
    }
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {
          if (this.options["muted"]) {
            this.videoPlayer.muted("true");
          }
          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100); // Wait 100 milliseconds and check again
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    document.documentElement.style.setProperty(
      "--footer-fixed-height",
      document.querySelector(".mainfooterWrapper").offsetHeight + "px"
    );
    responsive.addResizeListener(this, () => {
      document.documentElement.style.setProperty(
        "--footer-dynamic-height",
        document.querySelector(".mainfooterWrapper").offsetHeight + "px"
      );
    });
  }
}
customElements.define("footer-component", FooterComponent);

var contentCache = {};
sessionStorage.setItem("elementaryLoad", "true");
class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.carouselElement = this.element.querySelector(
      ".product-module__main-swiper"
    );
    this.yotpoPointsWidget = this.element.querySelector(".shopify-app-block:has(#yotpo-product-points-widget)");
    this.yotpoPointsWidgetPlaceholder = this.element.querySelector("#yotpo-points-widget__placeholder");

    this.drawerWrapper = this.element.querySelector('#product-module__shop-the-look-drawer');
    this.handle = this.element.querySelector('.drawer-handle__wrapper');

    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    this.lvhElem = document.getElementById('get-svh');

    this.stickySettings();

    // if (this.options["slides_number"] > 1) {
    this.carousel = new RevolutionSwiper(this.carouselElement);
    // }

    this.connectedItemsCarousel = this.element.querySelectorAll(
      ".product-module__connected-items-swiper"
    );
    this.connectedItemsCarousel.forEach(
      (swiper) => new RevolutionSwiper(swiper)
    );

    this.communityCarouselElement = this.element.querySelector(
      "#product-module__community-swiper"
    );
    this.buttonBackground = this.element.querySelector(
      ".product-module__toggle-button-background"
    );
    this.firstButton = this.element.querySelector(
      ".product-module__toggle-button"
    );
    this.communityToggler = this.element.querySelector('.product-module__slider-toggle');

    this.changeImageQuality();

    new AddToCart(this.element);

    if (this.options["enable_zoom"]) {
      new RevolutionImageZoom(this.carouselElement, this.carousel);
    }

    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");

    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    if (
      this.options["variant_image_id"] &&
      this.options["show_variant_image_on_load"]
    ) {
      this.updateImage();
    }

    this.shopTheLook = this.element.querySelector(
      ".product-module__product-slider-cell--shop"
    );
    this.hotSpots = this.element.querySelectorAll(
      ".product-module__product-highlight"
    );

    if (this.shopTheLook && this.hotSpots.length > 0) {
      this.shopDrawerElement = document.querySelector(
        "#product-module__shop-the-look-drawer"
      );
      this.shopDrawer = new Drawer(this.shopDrawerElement);
    }

    if (this.options["sticky_atc"]) {
      this.stickyAtcWrapper = this.element.querySelector(
        ".product-module__sticky-atc"
      );

      this.mainAtc = this.element.querySelector(
        ".product-module__product-atc-wrapper"
      );
      this.footer = document.querySelector("#shopify-section-main-footer");
    }

    this.navigation = this.element.querySelector(
      ".product-module__main-swiper .product-module__swiper-navigation"
    );

    this.initDragHandle();
    this.bindEvents();
  }

  // connectedCallback() {
  //   window.addEventListener("DOMContentLoaded", () => {
  //     if(this.yotpoPointsWidgetPlaceholder && this.yotpoPointsWidget) {
  //       this.yotpoPointsWidgetPlaceholder.appendChild(this.yotpoPointsWidget);
  //     }
  //   });
  // }

  bindEvents() {
    this.delegateElement.on("image:changed", this.updateImage.bind(this));
    this.delegateElement.on("variant:changed", this.updateModelInfo.bind(this));

    this.delegateElement.on("click", '#KiwiSizingChart', () => {
      this.buttonSizeBackground.style.transform = `translateX(0px)`;
      this.buttonSizeBackground.style.width = document.querySelector('.product-module__toggle-button-size').offsetWidth + 'px';
    }, true);

    window.addEventListener('popstate', function (event) {
      // Check if this is a back navigation (popstate triggered)
      if (event.state !== null) {
        // Force a page reload when the back button is clicked
        window.location.reload();
      }
    });

    if (this.options["sticky_atc"]) {
      scrollListener.addScrollListener(this, this.showStickyAtc.bind(this));
      this.delegateBody.on("product:added", this.hideStickyTimeout.bind(this));
      this.delegateBody.on("product:error", this.hideStickyTimeout.bind(this));
      window.addEventListener(
        "DOMContentLoaded",
        this.showStickyAtc.bind(this)
      );
    }

    if (this.options["sticky"]) {
      if (sessionStorage.getItem("elementaryLoad") === "true") {
        window.addEventListener("load", () => {
          this.headerHeight = document.querySelector("#header").offsetHeight;
          this.toggleSticky();
          this.loadSizingChart();
        });
      } else {
        this.loadSizingChart();
        this.headerHeight = document.querySelector("#header").offsetHeight;
        this.toggleSticky();
        yotpo.initWidgets();
      }
      responsive.addBreakpointListener("tablet_and_up");
      this.delegateBody.on(
        "breakpoint:tablet_and_up",
        this.toggleSticky.bind(this)
      );
      responsive.addResizeListener(this, this.toggleSticky.bind(this));

      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          this.toggleSticky();
        }
      });

      resizeObserver.observe(this.productInfo);
    }

    if (this.shopTheLook && this.hotSpots.length > 0) {
      this.delegateElement.on(
        "click",
        '[data-action="highlight"]',
        this.highlightProduct.bind(this)
      );

      responsive.addBreakpointListener("lap_and_up");
      this.delegateBody.on(
        "breakpoint:lap_and_up",
        this.toggleShopTheLook.bind(this)
      );
      this.toggleShopTheLook();
    }

    if (this.communityCarouselElement) {
      if (sessionStorage.getItem("elementaryLoad") === "true") {
        window.addEventListener("load", this.fetchImages.bind(this));
      } else {
        this.fetchImages();
      }

      this.delegateElement.on(
        "click",
        '[data-action="slider-toggle"]',
        this.toggleSlider.bind(this)
      );

      this.delegateBody.on(
        "click",
        '[data-action="slider-size-toggle"]',
        this.sizeButtonToggle.bind(this)
      );
    }

    window.addEventListener("DOMContentLoaded", () => {
      this.reloadWithoutRefresh();
    });

    this.delegateElement.on(
      "click",
      '[data-action="handle-reload"]',
      this.updateContentWithoutReload.bind(this)
    );

    if (
      this.options["video_controls"] &&
      this.element.querySelector("video-component")
    ) {
      this.carouselElement.swiper.on(
        "slideChange",
        this.movePaginationUp.bind(this)
      );
    }

    sessionStorage.setItem("elementaryLoad", "false");
  }

  initDragHandle() {
    let startY = 0, currentY = 0;
    const threshold = 80, wrap = this.drawerWrapper;
    if (!this.handle) { return; }
    this.handle.addEventListener('pointerdown', e => {
      startY = e.clientY;
      this.handle.setPointerCapture(e.pointerId);
      wrap.style.transition = 'none';
    });

    this.handle.addEventListener('pointermove', e => {
      if (!startY) return;
      currentY = e.clientY;
      const dy = currentY - startY;
      if (dy > 0) wrap.style.transform = `translateY(${dy}px)`;
    });

    this.handle.addEventListener('pointerup', e => {
      this.handle.releasePointerCapture(e.pointerId);
      wrap.style.transition = '';

      const dy = currentY - startY;

      if (currentY - startY > threshold) {
        this.shopDrawer.closeDrawer();
      } else {
        wrap.style.transform = '';
      }

      startY = currentY = 0;
    });
  }

  customizePopup() {
    try {
      const sizingChartElement = document.getElementById("KiwiSizingChart");
      const template = document.getElementById('product-module__size-chart');

      if (!template) return;

      // Define variables for interval and duration control
      let attempts = 0;
      const maxAttempts = 20; // Check for a maximum of 10 seconds
      const intervalDuration = 500; // 1 second interval

      // Define the interval function to repeatedly check for the modal
      const intervalId = setInterval(() => {
        const modalElement = document.querySelector('.kiwi-sizing-modal');

        if (modalElement) {
          sizingChartElement.style.pointerEvents = '';
          clearInterval(intervalId); // Clear the interval if modal is found

          // Proceed with the customization logic
          const content = template.content;

          const imgElement = content.querySelector('.product-module__size-image');
          const svgElement = content.querySelector('.hot-spot.product-module__size-svg');
          const sliderToggleDiv = content.querySelector('.product-module__size-toggle');

          this.buttonSizeBackground = sliderToggleDiv.querySelector('.product-module__toggle-size-button-background');

          modalElement.classList.add(sizingChartElement.getAttribute("data-color-group"));

          const imageParentElement = document.querySelector('.ks-modal-content');
          const toggleReferenceElement = document.querySelector('.ks-modal-tab-wrapper');
          const closeButtonElement = document.querySelector('.ks-modal-close');

          document.querySelector('.ks-modal-content .element-input[data-unit="kg"]')?.setAttribute("placeholder", window.languages.kg);
          document.querySelector('.ks-modal-content .element-input[data-unit="cm"]')?.setAttribute("placeholder", window.languages.cm);

          if (sliderToggleDiv && toggleReferenceElement) {
            toggleReferenceElement.insertAdjacentElement('afterend', sliderToggleDiv);
          }
          if (imageParentElement && imgElement) {
            imageParentElement.prepend(imgElement);
          }
          if (closeButtonElement && svgElement) {
            closeButtonElement.innerHTML = '';
            closeButtonElement.appendChild(svgElement);
          }

        } else {
          attempts++;

          if (attempts >= maxAttempts) {
            clearInterval(intervalId);
          }
        }
      }, intervalDuration);

    } catch (error) {
      console.error("Error customizing Kiwi Size Chart:", error);
    }
  }

  loadSizingChart() {
    try {
      const sizingChartElement = document.getElementById("KiwiSizingChart");

      if (sizingChartElement) {
        const productData = {
          productID: sizingChartElement.getAttribute("data-product"), // product.id
          title: sizingChartElement.getAttribute("data-product-name"), // product.title
          images: JSON.parse(sizingChartElement.getAttribute("data-product-images")), // product.images
        };

        if (sizingChartElement.hasAttribute("data-user-id")) {
          ks.setUserID(sizingChartElement.getAttribute("data-user-id"));
        }
        ks.setShopID(sizingChartElement.getAttribute("data-shop-id"));
        ks.loadSizing({
          productData: productData
        });

        this.customizePopup();
      }
    } catch (error) {
      console.error("Error in loading Kiwi Size Chart:", error);
    }
  }

  sizeButtonToggle(e) {
    const calculatorTab = document.querySelector(
      ".ks-calculator-tab-container"
    );
    const chartTab = document.querySelector(".ks-chart-tab-container");

    if (!chartTab || !calculatorTab) return;

    const buttonWidth = e.target.offsetWidth;
    const buttonPosition = e.target.offsetLeft;

    this.buttonSizeBackground.style.transform = `translateX(${buttonPosition}px)`;
    this.buttonSizeBackground.style.width = `${buttonWidth}px`;

    const targetId = e.target.dataset.id;

    if (targetId === "calculator") {
      calculatorTab.classList.remove("hide");
      chartTab.classList.add("hide");
      e.target.setAttribute("aria-expanded", "true");
      document
        .querySelector('button[data-id="chart"]')
        .setAttribute("aria-expanded", "false");
    } else if (targetId === "chart") {
      chartTab.classList.remove("hide");
      calculatorTab.classList.add("hide");
      e.target.setAttribute("aria-expanded", "true");
      document
        .querySelector('button[data-id="calculator"]')
        .setAttribute("aria-expanded", "false");
    }
  }

  hideStickyTimeout() {
    this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
    this.hideSticky = true;
    setTimeout(() => {
      this.hideSticky = false;
      this.showStickyAtc();
    }, 3000);
  }

  toggleShopTheLook() {
    if (responsive.matchesBreakpoint("lap_and_up")) {
      this.sideDeciderBinder = this.sideDecider.bind(this);
      this.hideAllHotspotsBinder = this.hideAllHotspots.bind(this);

      this.carouselElement.swiper.on(
        "slideChangeTransitionEnd",
        this.sideDeciderBinder
      );
      this.carouselElement.swiper.on("sliderMove", this.hideAllHotspotsBinder);

      window.addEventListener("DOMContentLoaded", this.sideDeciderBinder);
    } else {
      if (this.sideDeciderBinder) {
        this.carouselElement.swiper.off(
          "slideChangeTransitionEnd",
          this.sideDeciderBinder
        );
      }

      if (this.hideAllHotspotsBinder) {
        this.hideAllHotspots();
        this.carouselElement.swiper.off(
          "sliderMove",
          this.hideAllHotspotsBinder
        );
      }
    }
  }

  movePaginationUp() {
    if (!responsive.matchesBreakpoint("lap_and_up")) return;

    if (
      this.carouselElement.swiper.slides[
        this.carouselElement.swiper.activeIndex
      ].querySelector("video-component")
    ) {
      this.navigation.style.transform = "translateY(-100%)";
    } else {
      this.navigation.style.transform = "translateY(0)";
    }
  }

  async reloadWithoutRefresh() {
    let pdpUrls = this.element.querySelectorAll(
      ".product-module__reload .product-module__selectbox-reload"
    );
    let urlsToFetch = Array.from(pdpUrls).map((link) => link.href);

    const fetchAndCacheContent = async (url) => {
      try {
        const response = await fetch(url);

        if (response.ok) {
          const htmlContent = await response.text();
          contentCache[url] = new DOMParser()
            .parseFromString(htmlContent, "text/html")
            .querySelector(".section__product-module");
        } else {
          console.error("Error fetching data. HTTP status:", response.status);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    await Promise.all(urlsToFetch.map(fetchAndCacheContent));

    const preloadImages = (container) => {
      const images = container.querySelectorAll(
        ".product-module__product-slider-image--load-first"
      );
      images.forEach((img) => {
        const preloadedImage = new Image();
        preloadedImage.src = img.getAttribute("src");
      });
    };

    Object.values(contentCache).forEach(preloadImages);
  }

  getTitleFromUrl(url) {
    const parts = url.split("/");
    return parts[parts.length - 1];
  }

  updateContentWithoutReload(e) {
    e.preventDefault();
    const url = e.target.href;

    const htmlContent = contentCache[url];
    if (htmlContent) {
      history.pushState(null, null, url);

      document.body.querySelector(`.section__product-module`).innerHTML =
        htmlContent.innerHTML;

      window.scrollTo(0, 0);
      document.title = this.getTitleFromUrl(url);

      document.body.dispatchEvent(
        new CustomEvent("recommendations:reload", {
          bubbles: true,
          detail: htmlContent.querySelector('.product-module').dataset.productId
        })
      );

      Shopify.PaymentButton.init();
    } else {
      window.location.href = url;
    }
  }

  showStickyAtc() {
    if (this.hideSticky) return;
    if (
      window.scrollY + window.innerHeight <
      this.footer.getBoundingClientRect().top + window.scrollY &&
      window.scrollY >
      this.mainAtc.getBoundingClientRect().bottom + window.scrollY
    ) {
      this.stickyAtcWrapper.setAttribute("aria-hidden", "false");
    } else {
      this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
    }
  }

  scrolled() {
    this.hideAllHotspots();
    this.hideHotspot.removeScrollListener();
    this.hideHotspot = null;
  }

  highlightProduct(e) {
    e.stopPropagation();

    const parent = e.target.closest("[data-action]");
    const isExpanded = parent.getAttribute("aria-expanded") === "true";



    if (responsive.matchesBreakpoint("lap_and_up")) {
      this.toggleHotspot(parent, !isExpanded);
    } else {
      this.shopDrawerElement.querySelector(".drawer-dynamic-content").innerHTML = parent.querySelector("[aria-hidden]").outerHTML;
      this.shopDrawer.openDrawer();
    }

    this.clickHandler = (event) => {
      if (!parent.contains(event.target)) {
        this.toggleHotspot(parent, false);
        this.delegateElement.off("click", this.clickHandler);
      }
    };

    this.delegateElement.on("click", this.clickHandler);

    if (!this.hideHotspot) {
      this.hideHotspot = scrollListener.addScrollListener(
        this,
        this.scrolled.bind(this)
      );
    }
  }

  toggleHotspot(element, expand) {
    if (expand) this.hideAllHotspots();

    element.setAttribute("aria-expanded", expand.toString());
    element
      .querySelector("[aria-hidden]")
      .setAttribute("aria-hidden", (!expand).toString());
  }

  hideAllHotspots() {
    this.hotSpots.forEach((hotSpot) => {
      this.toggleHotspot(hotSpot, false);
    });
  }

  sideDecider() {
    this.hotSpots.forEach((element) => {
      const rect = element.getBoundingClientRect();
      const spaceToLeft = rect.left;
      const spaceToRight = window.innerWidth - rect.right;

      if (spaceToLeft > spaceToRight || this.element.querySelector('.product-module__product-slider-cell--shop').classList.contains('swiper-slide-next')) {
        element.classList.add("reverse");
      } else {
        element.classList.remove("reverse");
      }
    });
  }

  toggleSlider(e) {
    if (!this.allowClick) return;

    const buttonBackgroundWidth = this.firstButton.offsetWidth;
    const width = e.target.offsetWidth;
    const id = e.target.dataset.id;

    if (id == "community") {
      this.buttonBackground.style.transform = `translateX(${buttonBackgroundWidth}px)`;
      this.buttonBackground.style.width = `${width}px`;
    } else {
      this.buttonBackground.style.transform = `translateX(0)`;
      this.buttonBackground.style.width = `${width}px`;
    }

    const prevToggledButton = this.element.querySelector(
      '.product-module__toggle-button[aria-expanded="true"]'
    );
    const prevToggledSwiper = this.element.querySelector(
      '.swiper[aria-hidden="false"]'
    );

    prevToggledButton.setAttribute("aria-expanded", "false");
    prevToggledSwiper.setAttribute("aria-hidden", "true");

    e.target.setAttribute("aria-expanded", "true");
    this.element
      .querySelector(`#${e.target.getAttribute("aria-controls")}`)
      .setAttribute("aria-hidden", "false");
  }

  async fetchImages() {
    const endpoint = this.communityCarouselElement.dataset.endpoint;

    try {
      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not OK.");
      }

      const data = await response.json();
      var images = data.response.images;

      if (!images || images.length === 0) {
        return;
      }

      this.communityToggler.style.display = "";

      const container =
        this.communityCarouselElement.querySelector(".swiper-wrapper"); // Replace with your actual container selector

      let imagePosition = 0;
      let position = 0;

      if (responsive.matchesBreakpoint("lap_and_up") && images.length < 3) {
        this.communityCarouselElement.querySelector(
          ".product-module__swiper-navigation"
        ).style.display = "none";
      }

      let duplicated = false;
      if (images.length === 3) {
        duplicated = true;
        images = images.concat(images);
      }

      images.forEach((image, index) => {
        if (duplicated && index == 3) {
          imagePosition = 0;
        }

        const template = document.querySelector(
          ".product-module__community-slide-template"
        );
        const clone = document.importNode(template.content, true);

        const imageDiv = clone.querySelector(
          ".product-module__product-slider-element"
        );
        imageDiv.id = `product-module__image--${image.image_id}`;

        imageDiv.dataset.imagePosition = imagePosition;
        imageDiv.dataset.position = position;

        imagePosition++;
        position++;

        const imgElement = document.createElement("img");
        var src = image.medium_image_url;
        if (responsive.matchesBreakpoint("desktop_wide") || !image.original_image_url) {
          src = image.original_image_url;
        }
        if (!src) return;
        imgElement.src = src;
        imgElement.alt = window.languages.community_image_alt;

        if (
          imageDiv.hasAttribute("data-adapt") ||
          this.options["enable_zoom"]
        ) {
          const img = new Image();
          img.src = src;
          img.onload = () => {
            if (imageDiv.hasAttribute("data-adapt")) {
              const aspectRatio = img.width / img.height;
              imageDiv.style.setProperty("--aspect-ratio", aspectRatio);
            }
            if (this.options["enable_zoom"]) {
              imgElement.setAttribute("data-max-width", img.width);
              imgElement.setAttribute("data-max-height", img.height);
              imgElement.setAttribute("data-original-src", img.src);
            }
          };
        }

        imageDiv.appendChild(imgElement);
        container.appendChild(clone);
      });

      this.communityCarousel = new RevolutionSwiper(
        this.communityCarouselElement
      );
      if (this.options["enable_zoom"]) {
        new RevolutionImageZoom(
          this.communityCarouselElement,
          this.communityCarousel
        );
      }

      this.allowClick = true;

      setTimeout(() => {
        this.communityCarouselElement.swiper.update();
        if (images.length < 3 && responsive.matchesBreakpoint("lap_and_up")) {
          container.classList.add('zero');
          this.communityCarouselElement.swiper.disable();
        }
      }, 500);
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
    }
  }

  stickySettings() {
    if (this.options["sticky"]) {
      this.mainInfo = this.element.querySelector(".product-module__main-info");
      this.productInfo = this.element.querySelector(
        ".product-module__product-info"
      );
      this.wrapper = this.element.querySelector(".product-module__wrapper");
      this.slider = this.element.querySelector(
        ".product-module__product-slider-wrapper"
      );
    }
  }

  toggleSticky() {
    if (responsive.matchesBreakpoint("tablet_and_up")) {
      this.stickyOff();
    } else {
      this.stickyOn();
    }
  }

  stickyOff() {
    this.slider.style.marginBottom = `0px`;
    this.productInfo.style.marginTop = `0px`;
  }

  stickyOn() {
    const margin_one =
      this.wrapper.getBoundingClientRect().bottom -
      this.mainInfo.getBoundingClientRect().bottom;
    const margin_two = this.lvhElem.offsetHeight - this.slider.offsetHeight;

    this.slider.style.marginBottom = `${margin_one + Math.abs(margin_two) - this.headerHeight
      }px`;
    this.productInfo.style.marginTop = `-${margin_one + Math.abs(margin_two) - this.headerHeight
      }px`;
  }

  updateImage(event) {
    let imageID = null;
    if (event) {
      imageID = event.detail.new_image;
    } else {
      imageID = this.options["variant_image_id"];
    }

    var selector = "#product-module__image--" + imageID;
    var imageEl = this.element.querySelector(selector);

    if (imageEl) {
      let position = parseInt(imageEl.getAttribute("data-position"));
      this.carousel.selectCell(position);
    }
  }

  updateModelInfo(event) {
    if (event) {
      var imageID = event.detail.new_image;
    } else {
      var imageID = this.options["variant_image_id"];
    }

    var selector = "#product-module__image--" + imageID;
    var imageEl = this.element.querySelector(selector);

    if (imageEl) {
      this.carousel.selectCell(parseInt(imageEl.getAttribute("data-position")));
    }
  }

  updateModelInfo(event) {
    try {
      const script = document.querySelector('#variant-metafields[type="application/json"]');
      if (!script) return;

      const metafieldsJSON = script.textContent;
      if (!metafieldsJSON) return;

      const metafields = JSON.parse(metafieldsJSON);
      const variantId = event.detail?.variantId;
      if (!variantId || !metafields[variantId]) return;

      const model = metafields[variantId];
      const { name, height, size, image } = model;

      const modelContainer = this.element.querySelector(".product-module__model");
      if (name && height && size && image) {
        modelContainer.style.display = "flex";
      } else {
        modelContainer.style.display = "none";
      }

      const imgWrapper = this.element.querySelector(".product-module__model-image-wrapper");
      const oldImgElement = imgWrapper?.querySelector("img");

      if (image && imgWrapper) {
        const newImgElement = document.createElement("img");
        newImgElement.src = image;
        newImgElement.alt = `${name || "variant"}`;

        if (oldImgElement) {
          oldImgElement.replaceWith(newImgElement);
        } else {
          imgWrapper.appendChild(newImgElement);
        }
      }

      const info = this.element.querySelector(".product-module__model-info");
      if (info && name && height && size) {
        const modelText = window.languages.model;
        let replacedText = modelText.replace("{{ name }}", name);
        replacedText = replacedText.replace("{{ height }}", height);
        replacedText = replacedText.replace("{{ size }}", size);
        info.textContent = replacedText;
      }
    } catch (error) {
      console.error("Failed to update model info:", error);
      throw error;
    }
  }


  changeImageQuality() {
    var imagesToReveal = null;
    imagesToReveal = this.element.querySelectorAll(
      ".product-module__product-slider-image--load-first"
    );

    imagesToReveal.forEach((image) => {
      if (image !== null) {
        const replaceUrl = image
          .getAttribute("data-src")
          .replace("{width}x", "2600x");
        image.src = replaceUrl;
      }
    });
  }
}
customElements.define("product-component", ProductElement);

class OptionSelector extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.selectboxTitle = this.element.querySelectorAll(
      ".product-module__selectbox-title"
    );
    if (this.selectboxTitle.length < 1) {
      this.selectboxTitle = this.element.querySelectorAll(
        ".product-module__connected-items-label"
      );
    }
    this.selectedValue = this.selectboxTitle[0].innerHTML;

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "mouseenter",
      '[data-action="selectbox-hover"], [data-action="handle-reload"',
      this.selectboxSetValue.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseleave",
      '[data-action="selectbox-hover"], [data-action="handle-reload"]',
      this.selectboxResetValue.bind(this),
      true
    );

    this.delegateElement.on("option:changed", (e) => {
      this.selectedValue = e.detail;
      this.selectboxTitle.forEach(
        (title) => (title.innerHTML = this.selectedValue)
      );
    });
  }

  selectboxSetValue(e) {
    var value =
      e.target.getAttribute("data-value") || window.languages.undefined;
    this.selectboxTitle.forEach((title) => (title.innerHTML = value));
    if (this.resetTimeout) clearTimeout(this.resetTimeout);
  }

  selectboxResetValue() {
    this.resetTimeout = setTimeout(() => {
      this.selectboxTitle.forEach(
        (title) => (title.innerHTML = this.selectedValue)
      );
    }, 175);
  }
}
customElements.define("option-selector", OptionSelector);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.atcButtons = document.querySelectorAll(".product-module__product-atc");
    this.notifyButtons = document.querySelectorAll(
      ".product-module__product-atc-notify"
    );

    this.price = this.element.querySelector('.product-module__product-main-prices');
    this.outOfStockLabel = this.element.querySelector('.product-module__out-of-stock');

    this.regularPrice = document.querySelector('.product-module__regular-price span');
    this.comparePrice = document.querySelector('.product-module__compare-price');
    this.lowestPrice = document.querySelector('.product-module__product-price-lowest');
    this.lowestPriceSpan = document.querySelector('.product-price-lowest-money');

    this.notifyMeEnabled = document.querySelector("notify-me-popup");

    this.bindEvents();
    this.onVariantChange();
  }

  bindEvents() {
    this.delegateBody.on("quantity:changed", this.onQuantityChange.bind(this));

    this.delegateElement.on(
      "change",
      ".product-module__selectbox-select, .product-module__selectbox-checkbox",
      this.onVariantChange.bind(this)
    );
  }

  showNotifyMeButton(available) {
    if (!this.notifyButtons || !this.notifyMeEnabled) return;

    if (available) {
      this.notifyButtons.forEach((btn) => (btn.style.display = "none"));
      this.atcButtons.forEach((btn) => (btn.style.display = "block"));
    } else {
      this.notifyButtons.forEach((btn) => (btn.style.display = "block"));
      this.atcButtons.forEach((btn) => (btn.style.display = "none"));
    }
  }

  onQuantityChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
  }

  onVariantChange() {
    this.updateOptions();
    this.filterOptionsByValidCombinations(); // NEW: Filter using 2-out-of-3 logic
    this.updateMasterId();
    this.toggleAddButton();

    this.updateMedia();
    this.updateModel();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
    this.updateNotifyMe();
  }

  updateOptions(notify) {
    if (!notify) {
      this.options = Array.from(
        this.querySelectorAll(
          ".product-module__selectbox-select, .product-module__selectbox-checkbox:checked"
        ),
        (select) => select.value
      );
    } else {
      const optionsString = event.detail.values;
      this.options = optionsString.split("||");
    }
  }

  areArraysEqual(arrayOne, arrayTwo) {
    if (arrayOne.length !== arrayTwo.length) {
      return false;
    }

    const sortedArrayOne = arrayOne.slice().sort();
    const sortedArrayTwo = arrayTwo.slice().sort();

    return sortedArrayOne.every(
      (value, index) => value === sortedArrayTwo[index]
    );
  }

  isSubset(subset, array) {
    return subset.every((element) => array.includes(element));
  }

  // NEW: Map current selections to their correct positions
  mapSelectionsToPositions() {
    const positionedOptions = [null, null, null]; // [position0, position1, position2]

    if (!this.options || this.options.length === 0) return positionedOptions;

    const variants = this.getVariantData();

    // For each selected option, find which position it belongs to
    this.options.forEach(selectedValue => {
      // Find which position this value appears in most frequently
      const positionCounts = [0, 0, 0];

      variants.forEach(variant => {
        if (variant.options) {
          variant.options.forEach((optionValue, index) => {
            if (optionValue === selectedValue && index < 3) {
              positionCounts[index]++;
            }
          });
        }
      });

      // Put this value in the position where it appears most frequently
      const bestPosition = positionCounts.indexOf(Math.max(...positionCounts));
      if (bestPosition !== -1) {
        positionedOptions[bestPosition] = selectedValue;
      }
    });

    return positionedOptions;
  }

  // NEW: Main filtering method - simple and direct
  filterOptionsByValidCombinations() {
    // Show all options initially if no selection
    if (!this.options || this.options.length === 0) {
      this.showAllOptionContainers();
      return;
    }

    const variants = this.getVariantData();
    const positionedOptions = this.mapSelectionsToPositions(); // Map to correct positions

    // For each option position, find what values are valid
    for (let checkPosition = 0; checkPosition < 3; checkPosition++) {
      const validValues = this.getValidValuesForPosition(checkPosition, variants, positionedOptions);
      this.hideInvalidValuesAtPosition(checkPosition, validValues);
    }
  }

  // NEW: Get valid values for a specific position based on current selection
  getValidValuesForPosition(checkPosition, variants, positionedOptions) {
    const validValues = new Set();

    // Find variants that match the OTHER selected options (not the position we're checking)
    const matchingVariants = variants.filter(variant => {
      for (let i = 0; i < 3; i++) {
        if (i === checkPosition) continue; // Skip the position we're checking
        if (positionedOptions[i] && variant.options[i] !== positionedOptions[i]) {
          return false;
        }
      }
      return true;
    });

    // Collect all values at the check position from matching variants
    matchingVariants.forEach(variant => {
      if (variant.options[checkPosition]) {
        validValues.add(variant.options[checkPosition]);
      }
    });

    return Array.from(validValues);
  }

  // NEW: Hide option containers that have invalid values for this position
  hideInvalidValuesAtPosition(position, validValues) {
    const allContainers = document.querySelectorAll('.product-module__selectbox:has([data-value])');

    allContainers.forEach(container => {
      const valueElement = container.querySelector('[data-value]');
      if (valueElement) {
        const value = valueElement.getAttribute('data-value');

        // Check if this container belongs to the position we're checking
        const containerPosition = this.determineContainerPosition(container, value);

        if (containerPosition === position) {
          const shouldShow = validValues.includes(value);
          container.style.display = shouldShow ? '' : 'none';
        }
      }
    });
  }

  // NEW: Show all option containers
  showAllOptionContainers() {
    const allContainers = document.querySelectorAll('.product-module__selectbox:has([data-value])');
    allContainers.forEach(container => {
      container.style.display = '';
    });
  }

  // NEW: Determine which option position a container represents
  determineContainerPosition(container, value) {
    const variants = this.getVariantData();
    const positionOccurrences = [0, 0, 0];

    // Count how often this value appears in each position across all variants
    variants.forEach(variant => {
      if (variant.options) {
        variant.options.forEach((optionValue, index) => {
          if (optionValue === value && index < 3) {
            positionOccurrences[index]++;
          }
        });
      }
    });

    // Return the position where this value appears most frequently
    const maxOccurrences = Math.max(...positionOccurrences);
    return maxOccurrences > 0 ? positionOccurrences.indexOf(maxOccurrences) : -1;
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      if (this.areArraysEqual(this.options, variant.options)) {
        return true;
      }

      return this.isSubset(this.options, variant.options);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("image:changed", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateModelText() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateModel() {
    if (!this.currentVariant) return;

    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { variantId: this.currentVariant.id },
      })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateNotifyMe() {
    if (!this.notifyMeEnabled) return;
    const itemToClick = document.querySelector(
      `.RevolutionSelectbox--Item[data-selectboxid="product-module__notify-selector"][data-id="${this.currentVariant.id}"]`
    );
    if (itemToClick) {
      itemToClick.click();
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.productID}.product-module__product-form, #product-form-${this.productID}--sticky.product-module__product-form`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
    });
  }

  renderPrice() {
    if (this.price) {
      const regularPrice = Shopify.formatMoney(
        this.currentVariant.price,
        window.theme.moneyFormat
      );

      if (this.currentVariant.available) {
        this.regularPrice.innerHTML = regularPrice;

        this.price.style.display = "";
        this.outOfStockLabel.style.display = "none";
      } else {
        this.price.style.display = "none";
        this.outOfStockLabel.style.display = "";
      }

      if (this.currentVariant.compare_at_price && this.currentVariant.compare_at_price > this.currentVariant.price) {
        const comparePrice = Shopify.formatMoney(
          this.currentVariant.compare_at_price,
          window.theme.moneyFormat
        );

        this.comparePrice.innerHTML = comparePrice;
        this.comparePrice.style.display = "";
      } else {
        this.comparePrice.style.display = "none";
      }
    }
  }

  renderProductInfo() {
    this.renderPrice();
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = ".product-module__product-title";
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destinations = document.querySelectorAll(id);
        const source = html.querySelector(id);

        if (source && destinations) {
          destinations.forEach((destination) => {
            destination.innerHTML = source.innerHTML;
          });
        }

        const newPrice = html.querySelector('.product-price-lowest-money');
        const oldPrice = document.querySelector('.product-price-lowest-money');

        if (newPrice && oldPrice) {
          oldPrice.innerHTML = newPrice.innerHTML;
        }

        const quantityButton = document.querySelector(
          ".product-module__quantity-handler"
        );
        if (quantityButton) {
          const source = html.querySelector(
            ".product-module__quantity-handler"
          );
          if (source && quantityButton)
            quantityButton.innerHTML = source.innerHTML;
        }
        this.toggleAddButton();
      });
  }

  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelector(".product-module__product-atc"),
      addButtonInner = addButton.querySelectorAll(".ButtonText"),
      quantityEl = document.querySelector(".product-module__quantity-input"),
      altButtons = document.querySelectorAll(".product-module__alt-atc-button");
    if (quantityEl) {
      quantity = quantityEl.value;
    }
    if (window.variantInfo.show_icon) {
      var buySvg =
        '<svg class="mr-s" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M13.8888 6.66666V5.02777C13.8888 3.63841 13.1476 2.35458 11.9444 1.6599C10.7412 0.965215 9.25873 0.965215 8.0555 1.6599C6.85227 2.35458 6.11106 3.63841 6.11106 5.02777V8.91666C6.11106 9.22349 6.35979 9.47222 6.66661 9.47222C6.97344 9.47222 7.22217 9.22349 7.22217 8.91666V7.77777H11.6666V6.66666H7.22217V5.02777C7.22217 3.49365 8.46582 2.25 9.99995 2.25C11.5341 2.25 12.7777 3.49365 12.7777 5.02777V8.88889C12.7777 9.19571 13.0265 9.44444 13.3333 9.44444C13.6401 9.44444 13.8888 9.19571 13.8888 8.88889V7.77777H16.6666V17.7778H3.33328V7.77777H4.99995V6.66666H2.22217V17.8278C2.22217 18.4138 2.69724 18.8889 3.28328 18.8889H16.7166C17.3026 18.8889 17.7777 18.4138 17.7777 17.8278V6.66666H13.8888Z" fill="#272724" /> </svg>';
    } else {
      var buySvg = "";
    }

    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    if (!this.currentVariant || this.currentVariant.available == false) {
      addButton.setAttribute("disabled", "disabled");
      addButton.classList.add("product-module__product-atc--sold-out");
      addButtonInner.forEach((btn) => {
        btn.innerHTML = buySvg + window.variantStrings.soldOut;
      });
      altButtons.forEach(button => button.setAttribute("disabled", ""));
    } else {
      altButtons.forEach(button => button.removeAttribute("disabled"));
      addButton.removeAttribute("disabled");
      addButton.classList.remove("product-module__product-atc--sold-out");
      if (window.variantInfo.show_price) {
        var priceElement =
          "<span class='product-module__atc-price u-pb1'>&nbsp;&nbsp;-&nbsp;&nbsp;" +
          Shopify.formatMoney(
            this.currentVariant.price * quantity,
            window.theme.moneyFormat
          );
        +"</span>";
      } else {
        var priceElement = "";
      }

      addButtonInner.forEach((btn) => {
        btn.innerHTML = buySvg + window.variantStrings.addToCart + priceElement;
      });
    }

    this.showNotifyMeButton(this.currentVariant.available);
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantsProductCard extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.fakeSubmit = this.element.querySelector(".product-card__fake-submit");
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      '[data-action="input-change"]',
      this.onVariantChange.bind(this)
    );
  }

  onVariantChange(e) {
    const selectedLabel = this.element.querySelector(".size-labels--selected");
    if (selectedLabel) {
      selectedLabel.classList.remove("size-labels--selected");
    }

    this.element.querySelector(".product-card__input").value =
      event.target.value;
    for (let label of event.target.labels) {
      label.classList.add("size-labels--selected");
    }

    if (new Responsive().matchesBreakpoint("lap_and_up")) {
      this.fakeSubmit.click();
    }

    setTimeout(() => {
      e.target.checked = false;
    }, 1000);
  }
}

customElements.define("variants-product-card", VariantsProductCard);

class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.searchInputElement = this.element.querySelector('[name="q"]');

    this.searchResultsElement = this.element.querySelector(".searchWrapper");
    this.pageOverlayElement = this.element.querySelector(".sectionOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    this.clearSearchButton = this.element.querySelector(".searchInput--clear");
    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }
    this.headerTransparent = false;

    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.searchInputElement.offsetHeight + 48}px`
    );

    this.handle = this.element.querySelector('.drawer-handle__wrapper');
    this.searchWrapper = this.element.querySelector('.searchInnerWrapper');

    const originalClose = this.element.closeSearch.bind(this.element);
    this.element.closeSearch = () => {
      originalClose();
      setTimeout(() => {
        this.searchWrapper.style.transform = '';
      }, 500);
    };

    this.bindEvents();
    this.initDragHandle();
  }

  bindEvents() {
    this._onInputListener = this.debounce(this.onInput.bind(this), 450);

    this.delegateBody.on(
      "click",
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.resetSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );

    this.searchInputElement.addEventListener("input", this._onInputListener);

    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateBody.on(
      "keydown",
      this.onEsc.bind(this)
    );

    this.delegateBody.on("menu:open", this.closeSearch.bind(this));
    this.delegateBody.on("close:search", this.closeSearch.bind(this));
  }

  debounce(fn, delay) {
    var _this0 = this;

    var timer = null;

    return function () {
      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(_this0, args);
      }, delay);
    };
  }

  onEsc(e) {
    if (e.key === 'Escape') {
      this.closeSearch(this.element);
    }
  }


  initDragHandle() {
    let startY = 0, currentY = 0;
    const threshold = 80, wrap = this.searchWrapper;
    if (!this.handle) { return; }
    this.handle.addEventListener('pointerdown', e => {
      startY = e.clientY;
      this.handle.setPointerCapture(e.pointerId);
      wrap.style.transition = 'none';
    });

    this.handle.addEventListener('pointermove', e => {
      if (!startY) return;
      currentY = e.clientY;
      const dy = currentY - startY;
      if (dy > 0) wrap.style.transform = `translateY(${dy}px)`;
    });

    this.handle.addEventListener('pointerup', e => {
      this.handle.releasePointerCapture(e.pointerId);
      wrap.style.transition = '';

      if (currentY - startY > threshold) {
        this.element.closeSearch();
      } else {
        wrap.style.transform = '';
      }

      startY = currentY = 0;
    });
  }

  openSearch(event) {
    event.preventDefault();

    const _this = this;
    // Check if search is already open, close it if true
    if (this.isOpen) {
      this.closeSearch();
      return;
    }

    this.element.style.display = "flex";

    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );

    this.element.dispatchEvent(
      new CustomEvent("drawer:close-other", { bubbles: true })
    );

    // Check if search element exists
    if (!this.element) {
      console.error("Search element not found");
      return;
    }

    // Show search element and page overlay
    const search = document.querySelector("#quickSearch");
    if (search) {
      search.setAttribute("aria-hidden", false);
    }

    // Disable scrolling on body
    bodyScrollLock.disableBodyScroll(
      this.element.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );

    // Focus on search input element after delay
    setTimeout(() => {
      if (_this.searchInputElement) {
        _this.searchInputElement.focus();
      }
    }, 200);

    // Set isOpen to true
    this.isOpen = true;

    // Add event listener to page overlay to close search
    if (this.pageOverlayElement) {
      this.closeListener = this.closeSearch.bind(this);
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener("click", this.closeListener);
    }
  }

  closeSearch() {
    event.preventDefault();

    if (!this.isOpen) {
      return;
    }
    bodyScrollLock.enableBodyScroll(
      this.element.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );
    this.element.setAttribute("aria-hidden", true);
    const transitionElement = this.element.querySelector(".searchInnerWrapper");

    const transitionEndHandler = () => {
      this.element.style.display = "none";
      transitionElement.removeEventListener(
        "transitionend",
        transitionEndHandler
      );
    };

    transitionElement.addEventListener("transitionend", transitionEndHandler);

    this.pageOverlayElement.classList.remove("is-visible");

    this.isOpen = false;
  }

  async onInput(event) {
    this.allPredictiveSearchInstances = [];
    this.lastInputValue = event.target.value;
    this.searchResultsElement = this.element.querySelector(".searchWrapper");
    this.searchResultsElement.style.opacity = 0;
    this.clearSearchButton.setAttribute("aria-hidden", "false");
    if (event.target.getAttribute("data-value") && this.lastInputValue === 0) {
      this.lastInputValue = event.target.getAttribute("data-value");
      const el = this.element.querySelector(".searchInput");

      el.setAttribute("value", this.lastInputValue);
      el.value = this.lastInputValue;
    } else {
      if (this.lastInputValue === "") {
        this.initialSearchLayout.style.opacity = 0;
        this.resetSearch();
        return;
      }
    }

    try {
      const response = await fetch(
        `${routes.predictive_search_url}?q=${encodeURIComponent(
          this.lastInputValue
        )}&resources[limit_scope]=each&section_id=search-predictive&resources[limit]=4`
      );

      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }

      const text = await response.text();
      const resultsMarkup = new DOMParser()
        .parseFromString(text, "text/html")
        .querySelector("#shopify-section-search-predictive").innerHTML;

      // Save bandwidth keeping the cache in all instances synced
      this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
        predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
      });
      const div = document.createElement("div");
      div.innerHTML = resultsMarkup;

      this.searchResultsElement.innerHTML = resultsMarkup;

      this.searchResultsElement.style.opacity = 1;

      if (window.theme.showRecentSearches) {
        this.recentSearches();
      }
    } catch (error) {
      if (error?.code === 20) {
        // Code 20 means the call was aborted
        return;
      }

      throw error;
    }
  }

  resetSearch() {
    this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;
    const currentSuggestedQueries = this.element.querySelector(
      ".predictiveSearch--queries"
    );
    if (currentSuggestedQueries) currentSuggestedQueries.remove();
    this.searchInputElement.value = "";
    this.searchInputElement.removeAttribute("value");

    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }

    this.searchResultsElement.style.opacity = 1;
    this.clearSearchButton.setAttribute("aria-hidden", "true");
  }

  recentSearches() {
    if (this.lastInputValue.length > 3) {
      var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }

      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem(
          "searchTerms",
          JSON.stringify(searchTerm.slice(0, 5))
        );
      } catch (error) { }
    }
  }

  getRecentSearches() {
    let appendString = "";
    const items = JSON.parse(localStorage.getItem("searchTerms") || "[]");
    let elementToAdd = this.element.querySelector(".search--recentResults");
    if (items.length > 0) {
      items.forEach((id) => {
        appendString =
          appendString +
          "<li role='option' tabIndex='0' class='hoverLinks u-s3' data-action='search-string' data-value='" +
          id +
          "'>" +
          id +
          "</li>";
      });

      elementToAdd.innerHTML = appendString;
      if (this.querySelector(".searchWrapper--initial")) {
        this.querySelector(".searchWrapper--initial").classList.add(
          "predictiveSearch--twoColumns"
        );
      }
    } else {
      this.querySelector("#predictiveSearch--recentSearches").style.display =
        "none";
      if (
        this.querySelector(
          ".searchWrapper--initial.predictiveSearch--twoColumns"
        )
      ) {
        this.querySelector(
          ".searchWrapper--initial.predictiveSearch--twoColumns"
        ).classList.remove("predictiveSearch--twoColumns");
      }
    }
  }
}
customElements.define("search-bar", SearchBar);

class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );
  }

  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });
    if (this.buttonState == true) {
      this.element.querySelector(".Contact-Btn").removeAttribute("disabled");
    } else {
      this.element.querySelector(".Contact-Btn").setAttribute("disabled", true);
    }
  }
}

customElements.define("contact-section", ContactSection);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    if (window.location.href.indexOf("customer_posted=true#popupForm") > -1) {
      this.options.delay = 0;
      this.openNewsletter();
    }

    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
    }
  }

  handleOpenOptions() {
    const localKey = localStorage.getItem("popup-seen");

    if (this.options.show_only_once && localKey === "true") return;

    if (this.options.scroll_amount > 0) {
      this.myScrollListener = scrollListener.addScrollListener(
        this,
        this.scrollListener
      );
    } else {
      this.openNewsletter();
    }
  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  openNewsletter() {
    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
    }
    setTimeout(() => {
      this.element.setAttribute("aria-hidden", false);

      this.pageOverlayElement.classList.add("is-visible");

      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);

      this.pageOverlayElement.addEventListener("click", this.closeNewsletter);

      localStorage.setItem("popup-seen", true);

      this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.closeNewsletter
      );
    }, 1000 * this.options.delay);
  }

  closeNewsletter = () => {
    this.element.setAttribute("aria-hidden", true);
    this.pageOverlayElement.classList.remove("is-visible");
    bodyScrollLock.clearAllBodyScrollLocks();

    this.pageOverlayElement.removeEventListener("click", this.closeNewsletter);

    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
    }
  };
}

customElements.define("newsletter-popup", NewsletterPopup);

class AthleteClubPasswordForm extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
  }

  connectedCallback() {
    this.initAccessSettings();
    this.initErrorElements();
    this.handleLoginState();
    this.handleLoginErrorParam();
    this.bindEvents();
  }

  initAccessSettings() {
    this.accessSettingsElement = this.querySelector("#ac-settings");
    if (this.accessSettingsElement?.textContent) {
      try {
        this.accessSettings = JSON.parse(this.accessSettingsElement.textContent);
      } catch (error) {
        console.error("Failed to parse access settings JSON:", error);
        this.accessSettings = {};
      }
    } else {
      this.accessSettings = {};
    }
  }

  initErrorElements() {
    this.athleteClubPasswordError = this.querySelector(".ac__access-password-error");
    this.athleteClubAccessError = this.querySelector(".ac__access-access-error");
  }

  handleLoginState() {
    const isLoggedIn = this.accessSettings.loggedIn;
    if (isLoggedIn === true) {
      this.checkAccess();
    }
  }

  handleLoginErrorParam() {
    const urlParams = new URLSearchParams(window.location.search);
    const hasLoginError = urlParams.get("loginError") === "true";
    if (hasLoginError && this.athleteClubPasswordError) {
      this.athleteClubPasswordError.style.display = "block";
    }
  }


  checkAccess() {
    const _this = this;
    const now = new Date();
    const tier = this.accessSettings?.swellVipTier || "";

    // Check each tier: if handle exists and matches user's tier, check date
    const isContender = _this.accessSettings.handleContender &&
      tier === _this.accessSettings.handleContender &&
      now >= new Date(_this.accessSettings.dateTimeContender);

    const isChallenger = _this.accessSettings.handleChallenger &&
      tier === _this.accessSettings.handleChallenger &&
      now >= new Date(_this.accessSettings.dateTimeChallenger);

    const isChampion = _this.accessSettings.handleChampion &&
      tier === _this.accessSettings.handleChampion &&
      now >= new Date(_this.accessSettings.dateTimeChampion);

    const hasAccess = isContender || isChallenger || isChampion;
    const linkButton = _this.element.querySelector(".ac__access-link-button");

    if (!hasAccess) {
      _this.athleteClubAccessError.style.display = "block";

      if (linkButton) {
        linkButton.style.display = "flex";
        linkButton.setAttribute("aria-disabled", "true");
      }

      return;
    }

    const formContainer = _this.element.querySelector(".ac__login-form");
    if (formContainer) formContainer.style.display = "none";

    if (linkButton) {
      linkButton.style.display = "flex";
      linkButton.setAttribute("aria-disabled", "false");
    }
  }

  bindEvents() {
    this.delegateElement.on('click', '.ac__access-submit-button', this.onSubmitHandler.bind(this));
  }

  onSubmitHandler(e) {
    e.preventDefault();
    this.element.querySelector(".itemLoader")?.classList.add("is-visible");
    this.athleteClubPasswordError.style.display = "none";

    // Submit the native Shopify form directly
    const form = this.element.querySelector('#athlete-club__login-form');
    const emailInput = this.element.querySelector('input[name="customer[email]"]');
    const passwordInput = this.element.querySelector('input[name="customer[password]"]');

    if (form) {
      const email = emailInput.value.trim();
      const password = passwordInput.value.trim();
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

      if (email && isValidEmail && password) {
        form.submit();
      } else {
        if (!email || !isValidEmail) {
          emailInput.setAttribute("aria-invalid", "true");
        } else {
          emailInput.removeAttribute("aria-invalid");
        }

        if (!password) {
          passwordInput.setAttribute("aria-invalid", "true");
        } else {
          passwordInput.removeAttribute("aria-invalid");
        }

        // Hide loader
        this.element.querySelector(".itemLoader")?.classList.remove("is-visible");
      }
    }
  }
}

customElements.define("athlete-club-password-form", AthleteClubPasswordForm);



class AthleteTierDisplay extends HTMLElement {
  constructor() {
    super();

    this.element = this;
    this.delegateElement = new Delegate(this.element);
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.extractTierDataAndCleanup();
  }

  extractTierDataAndCleanup() {
    const timeout = setTimeout(() => {
      this.displayTierInfo({
        currentTier: "Unknown tier",
        nextTier: "N/A",
        nextTierMoneyNeeded: "-",
      });
      observer.disconnect();
    }, 5000);

    const observer = new MutationObserver(() => {
      const currentTier = this.element.querySelector(".yotpo-vip-tiers-progress-bar-summary-current .yotpo-templated-variable")?.innerText?.trim();
      const nextTier = this.element.querySelector(".yotpo-progress-bar-top-right")?.innerText?.trim();
      const nextTierMoneyNeeded = this.element.querySelector(".yotpo-vip-tiers-progress-bar-summary-next .yotpo-templated-variable")?.innerText?.trim();

      const hasAllData = currentTier || nextTier || nextTierMoneyNeeded;

      if (hasAllData) {
        this.displayTierInfo({
          currentTier: currentTier || "Unknown tier",
          nextTier: nextTier || "N/A",
          nextTierMoneyNeeded: nextTierMoneyNeeded || "-",
        });

        // Remove original Yotpo widget
        this.element.querySelector('.yotpo-vip-tiers-widget')?.remove();

        clearTimeout(timeout);
        observer.disconnect();
      }
    });

    observer.observe(this.element, {
      childList: true,
      subtree: true,
    });
  }


  displayTierInfo({ currentTier, nextTier, nextTierMoneyNeeded }) {
    const statusButton = this.element.querySelector(".pp__tier-information__status__tier");
    if (statusButton) statusButton.innerHTML = " " + currentTier;

    const spendMoreTier = this.element.querySelector(".pp__tier-information__next-tier__money");
    if (spendMoreTier) spendMoreTier.textContent = nextTierMoneyNeeded;

    const spendMoreMoney = this.element.querySelector(".pp__tier-information__next-tier__tier");
    if (spendMoreMoney) spendMoreMoney.textContent = nextTier;
  }
}

customElements.define("section-customer-tier-information", AthleteTierDisplay);


class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.drawerElement = this.element.querySelector("#account__drawer");
    this.drawer = new Drawer(this.drawerElement);
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="toggle-tab"]',
      this.toggleTab.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="submit-login"]',
      this.submitLogin.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="submit-register"]',
      this.submitRegistration.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-recovery"]',
      this.toggleRecovery.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="submit-recovery"]',
      this.accountRecover.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="submit-input-login"]',
      this.accountInputSubmit.bind(this)
    );
    this.delegateElement.on(
      "keypress",
      '[data-action="submit-input-reg"]',
      this.accountInputSubmitReg.bind(this)
    );
    this.delegateElement.on(
      "keypress",
      '[data-action="submit-input-forgot-pass"]',
      this.accountInputSubmitForgot.bind(this)
    );
  }

  accountInputSubmit(event) {
    if (event.key === "Enter") this.submitLogin(event);
  }
  accountInputSubmitReg(event) {
    if (event.key === "Enter") this.submitRegistration(event);
  }
  accountInputSubmitForgot(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.accountRecover(event);
    }
  }

  toggleRecovery() {
    event.preventDefault();
    const id = event.target.dataset.id;

    if (id == "account__recover-container") {
      this.element
        .querySelector("#account__recover-container")
        .setAttribute("aria-visible", "true");
      this.element
        .querySelector("#account__signup-action")
        .setAttribute("aria-visible", "false");
    } else {
      this.element
        .querySelector("#account__recover-container")
        .setAttribute("aria-visible", "false");
      this.element
        .querySelector("#account__signup-action")
        .setAttribute("aria-visible", "true");
    }
  }

  accountRecover(event) {
    event.preventDefault();
    const _this = this;
    const registrationEndpoint = "/account/recover";

    // Create the request body with the registration data
    const requestBody = {
      email: this.element.querySelector("#account__recover-email-input").value,
    };

    event.target
      .closest("form")
      .querySelector(".itemLoader")
      ?.classList.add("is-visible");

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(registrationEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responseText = await response.text();
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = responseText;

        if (responseText.indexOf("account__recover-email-error") !== -1) {
          _this.element.querySelector(
            "#account__recover-container .account__form-success-msg"
          ).innerHTML = "";
          _this.element.querySelector(
            "#account__recover-container .account__form-error"
          ).innerHTML =
            '<span class="AlertErrorInner pt-m u-p4">' +
            tempDiv.querySelector("#account__recover-email-error").innerHTML +
            "</span>";
        } else if (responseText.indexOf("account__form-success-msg") !== -1) {
          _this.element.querySelector(
            "#account__recover-container .account__form-error"
          ).innerHTML = "";
          _this.element.querySelector(
            "#account__recover-container .account__form-success-msg"
          ).innerHTML =
            '<span class="AlertErrorInner pt-m u-p4">' +
            tempDiv.querySelector("#account__form-success-msg").innerHTML +
            "</span>";
        } else if (
          responseText.indexOf("shopify-challenge__container") !== -1
        ) {
          location.href = "/challenge";
        }
        event.target
          .closest("form")
          .querySelector(".itemLoader")
          ?.classList.remove("is-visible");
      } catch (error) {
        console.log(
          "An error occurred during the registration request:",
          error
        );
      }
    })();
  }

  submitRegistration(event) {
    event.preventDefault();
    const _this = this;
    const registrationEndpoint = "/account";

    // Create the request body with the registration data
    const requestBody = {
      customer: {
        first_name: this.element.querySelector(
          "#account__register-container #account__register-first-name-input"
        ).value,
        last_name: this.element.querySelector(
          "#account__register-container #account__register-last-name-input"
        ).value,
        email: this.element.querySelector(
          "#account__register-container #account__register-email-input"
        ).value,
        password: this.element.querySelector(
          "#account__register-container #account__register-password-input"
        ).value,
      },
    };

    event.target
      .closest("form")
      .querySelector(".itemLoader")
      ?.classList.add("is-visible");

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(registrationEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responseText = await response.text();

        if (responseText.indexOf("registerErrors") !== -1) {
          console.log("Error occurred during registration");
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = responseText;

          const emailError = tempDiv.querySelector(
            "#account__register-email-error"
          );
          const passwordError = tempDiv.querySelector(
            "#account__register-password-error"
          );

          if (emailError)
            _this.element.querySelector(
              "#account__register-email-error"
            ).innerHTML = `<div class="AlertErrorInner u-p4 pt-m">${tempDiv.querySelector("#account__register-email-error").innerHTML
            }</div>`;
          if (passwordError)
            _this.element.querySelector(
              "#account__register-password-error"
            ).innerHTML = `<div class="AlertErrorInner u-p4 pt-m">${tempDiv.querySelector("#account__register-password-error")
              .innerHTML
            }</div>`;
        } else if (
          responseText.indexOf("shopify-challenge__container") !== -1
        ) {
          location.href = "/challenge";
        } else {
          location.href = window.routes.account_url;
        }
        event.target
          .closest("form")
          .querySelector(".itemLoader")
          ?.classList.remove("is-visible");
      } catch (error) {
        console.log(
          "An error occurred during the registration request:",
          error
        );
      }
    })();
  }

  submitLogin(event) {
    event.preventDefault();
    const _this = this;
    const loginEndpoint = "/account/login";

    // Create the request body with the login credentials
    const requestBody = {
      customer: {
        email: this.element.querySelector(
          "#account__login-container #account__login-email-input"
        ).value,
        password: this.element.querySelector(
          "#account__login-container #account__login-password-input"
        ).value,
      },
    };

    event.target
      .closest("form")
      .querySelector(".itemLoader")
      ?.classList.add("is-visible");

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(loginEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responseText = await response.text();

        if (responseText.indexOf("loginError") !== -1) {
          console.log("Incorrect email or password");
          const tempDiv = document.createElement("div");

          tempDiv.innerHTML = responseText;

          _this.element.querySelector(
            "#account__login-container .account__form-error"
          ).innerHTML = `<div class="AlertErrorInner u-p4 pb-m">${tempDiv.querySelector(".AlertError").innerHTML
          }</div>`;

          event.target
            .closest("form")
            .querySelector(".itemLoader")
            ?.classList.remove("is-visible");
        } else if (
          responseText.indexOf("shopify-challenge__container") !== -1
        ) {
          location.href = "/challenge";
        } else {
          location.href = window.routes.account_url;
        }
      } catch (error) {
        console.log("An error occurred during the login request:", error);
      }
    })();
  }

  toggleTab(e) {
    e.preventDefault();

    const allTabs = this.element.querySelectorAll(
      '.account__action-tab[aria-expanded="true"]'
    );
    const allContent = this.element.querySelectorAll(
      '.account__action-container[aria-hidden="false"]'
    );
    const tabBackgrounds = this.element.querySelectorAll(
      ".account__action-tab--background"
    );
    const id = e.target.getAttribute("aria-controls");

    allTabs.forEach((tab) => tab.setAttribute("aria-expanded", "false"));
    allContent.forEach((tab) => tab.setAttribute("aria-hidden", "true"));

    this.element
      .querySelectorAll(`.account__action-tab[data-id="${id}"]`)
      .forEach((el) => el.setAttribute("aria-expanded", "true"));

    if (id == "account__register-container") {
      tabBackgrounds.forEach(
        (tab) => (tab.style.transform = `translateX(calc(100% + 1.5rem))`)
      );
    } else {
      tabBackgrounds.forEach((tab) => (tab.style.transform = `translateX(0)`));
    }

    this.element
      .querySelectorAll(`.account__action-tab[aria-controls="${id}"]`)
      .forEach((el) => el.setAttribute("aria-expanded", "true"));
    this.element.querySelector(`#${id}`).setAttribute("aria-hidden", "false");
  }
}

customElements.define("account-handler", AccountHandler);

class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    new Popup(this.element, true);
  }
}
customElements.define("localization-selectors", LocalizationSelectors);

class AnimatedAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.blocks = Array.from(
      this.element.querySelectorAll(".announcementBar--Block")
    );
    this.currentBlockIndex = 0;
    this.transitionSpeed =
      parseInt(this.element.getAttribute("data-settings")) * 1000;
    this.announcementBar = document.querySelector(".announcementBar");

    document.documentElement.style.setProperty(
      "--announcement-fixed-height",
      this.element.clientHeight + "px"
    );

    this.initBlocks();

    if (
      typeof this.transitionSpeed === "number" &&
      !isNaN(this.transitionSpeed)
    ) {
      if (this.blocks.length > 1) {
        this.startAnimating();
      }
    }
    this.updateVisibleHeight();
    this.updateVisibleHeightListener = this.updateVisibleHeight.bind(this);
    scrollListener.addScrollListener(this, this.updateVisibleHeightListener);
  }

  initBlocks() {
    this.blocks.forEach((block, index) => {
      if (index == 0) {
        block.style.opacity = 1;
        block.style.display = "flex";
      } else {
        block.style.opacity = 0;
        block.style.display = "none";
      }
    });
  }

  updateVisibleHeight() {
    const rect = this.announcementBar.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight =
      Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);

    // Update the height of .announcementBar with the visible height
    document.documentElement.style.setProperty(
      "--announcement-dynamic-height",
      `${visibleHeight}px`
    );
  }

  startAnimating() {
    setInterval(() => {
      this.showNextBlock();
    }, this.transitionSpeed);
  }

  showNextBlock() {
    const currentBlock = this.blocks[this.currentBlockIndex];
    const nextBlockIndex = (this.currentBlockIndex + 1) % this.blocks.length;
    const nextBlock = this.blocks[nextBlockIndex];

    // Fade out current block

    currentBlock.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 500,
      fill: "forwards",
      easing: "ease-out",
    }).onfinish = () => {
      currentBlock.style.display = "none";

      // Show next block
      nextBlock.style.display = "flex";
      nextBlock.animate(
        [
          { opacity: 0, transform: "translateY(10px)" },
          { opacity: 0.2, transform: "translateY(5px)" },
          { opacity: 1, transform: "translateY(0)" },
        ],
        {
          duration: 500,
          fill: "forwards",
          easing: "ease-out",
        }
      );
    };

    this.currentBlockIndex = nextBlockIndex;
  }
}

customElements.define("announcement-bar", AnimatedAnnouncementBar);

class ShopLookSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".swiper");
    const swiperInstance = new RevolutionSwiper(this.carouselElement);
    this.currentSwiper = swiperInstance;
    this.currentSwiper.swiperElement.activeIndex = 0;
    this.currentSwiper.swiperElement.on("slideChangeTransitionEnd", () => {
      this.handleSlideChangeTransitionEnd(this.element);
    });

    document.addEventListener("DOMContentLoaded", () => {
      this.initializeHeadingButtons();
    });

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=change-tab]",
      this.handleHeadingButtonClick.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action=change-slide]",
      this.handleProductButtonClick.bind(this)
    );

    this.delegateElement.on(
      "mouseover",
      "[data-action=change-slide]",
      this.handleProductMouseOver.bind(this)
    );

    this.delegateElement.on(
      "mouseleave",
      "[data-action=change-slide]",
      this.handleProductMouseLeave.bind(this)
    );
  }

  //Add active class to first heading button, display first block
  initializeHeadingButtons() {
    const parentElement = this.querySelector(".shop-look__heading-buttons");
    const buttons = this.querySelectorAll(".heading-button");
    const blocks = this.querySelectorAll(".shop-look__content-block");

    if (buttons.length > 0) {
      buttons[0].classList.add("heading-button--active");
      const buttonAnimationDiv = this.element.querySelector(
        ".button-overlay--animation"
      );

      //Calculate button container height and adjust animation in case of multiline buttons
      const computedStyle = window.getComputedStyle(parentElement);
      const paddingTop = parseFloat(computedStyle.paddingTop);
      const paddingBottom = parseFloat(computedStyle.paddingBottom);
      const totalHeight = parentElement.offsetHeight;
      const heightWithoutPadding = totalHeight - paddingTop - paddingBottom;
      const isMultiLine = heightWithoutPadding > buttons[0].offsetHeight;

      if (isMultiLine) {
        parentElement.classList.add("multi-line-btn__container");
      } else {
        parentElement.classList.remove("multi-line-btn__container");
      }

      const buttonWidth = buttons[0].offsetWidth;
      const buttonLeft = buttons[0].offsetLeft;
      // const buttonHeight = buttons[0].offsetHeight;
      const buttonTop = buttons[0].offsetTop;

      buttonAnimationDiv.style.width = `${buttonWidth}px`;
      // buttonAnimationDiv.style.height = `${buttonHeight}px`;
      buttonAnimationDiv.style.transform = `translate(${buttonLeft}px, ${buttonTop}px)`;
      buttons[0].classList.add("heading-button--active");

      blocks.forEach((block, index) => {
        if (index === 0) {
          block.classList.add("shop-look__content-block--active");
        }
      });
    }
  }

  //Handle user interaction with slides, add active class to product buttons based on activeIndex
  handleSlideChangeTransitionEnd(element) {
    const activeIndex = this.currentSwiper.swiperElement.activeIndex;
    const clickedProductBtn = element.querySelector(
      `[data-slide-index="${activeIndex}"]`
    );
    const allProductBtns = this.element.querySelectorAll(
      "[id^='product__movable-icon-']"
    );

    allProductBtns.forEach((productBtn) => {
      productBtn.classList.remove("icon-circle--active");
    });

    if (
      clickedProductBtn &&
      !clickedProductBtn.classList.contains("icon-circle--active")
    ) {
      clickedProductBtn.classList.add("icon-circle--active");
    }
  }

  //Display block depending on targetId from heading btn, initialize or destroy swiper instance on heading button click, add active class to first product button in target block
  handleHeadingButtonClick(event) {
    const currentHeadingButton = event.target;
    const targetId = currentHeadingButton.getAttribute("data-target");
    const buttonAnimationDiv = this.element.querySelector(
      ".button-overlay--animation"
    );
    const blocks = this.querySelectorAll(".shop-look__content-block");

    blocks.forEach((block) => {
      block.classList.remove("shop-look__content-block--active");
    });

    const targetBlock = this.querySelector(`#${targetId}`);
    if (targetBlock) {
      if (this.currentSwiper) {
        this.currentSwiper.swiperElement.destroy(true, false);
      }
      targetBlock.classList.add("shop-look__content-block--active");
      const productButtons = targetBlock.querySelectorAll(
        "[id^='product__movable-icon-']"
      );
      productButtons.forEach((button, index) => {
        button.classList.toggle("icon-circle--active", index === 0);
      });

      const allHeadingButtons = this.querySelectorAll(".heading-button");
      allHeadingButtons.forEach((btn) =>
        btn.classList.remove("heading-button--active")
      );
      setTimeout(function () {
        currentHeadingButton.classList.add("heading-button--active");
      }, 50);

      const buttonWidth = currentHeadingButton.offsetWidth;
      // const buttonHeight = currentHeadingButton.offsetHeight;
      const buttonTop = currentHeadingButton.offsetTop;
      const buttonLeft = currentHeadingButton.offsetLeft;
      buttonAnimationDiv.style.width = `${buttonWidth}px`;
      // buttonAnimationDiv.style.height = `${buttonHeight}px`;
      buttonAnimationDiv.style.transform = `translate(${buttonLeft}px, ${buttonTop}px)`;

      this.carouselElement = targetBlock.querySelector(".swiper");
      const swiperInstance = new RevolutionSwiper(this.carouselElement);
      this.currentSwiper = swiperInstance;
      this.currentSwiper.swiperElement.activeIndex = 0;
      this.currentSwiper.swiperElement.on("slideChangeTransitionEnd", () => {
        this.handleSlideChangeTransitionEnd(targetBlock);
      });
    }
  }

  handleProductMouseOver(event) {
    this.handleProductButtonClick(event);
  }

  handleProductMouseLeave(event) {
    const activeBtn = this.element.querySelector(".icon-circle--active");
    if (activeBtn) {
      activeBtn.classList.remove("icon-circle--active");
    }
  }

  //Remove active class from all product buttons, add active class to clicked product button
  handleProductButtonClick(event) {
    const clickedProductBtn = event.target;
    const allProductBtns = this.element.querySelectorAll(
      "[id^='product__movable-icon-']"
    );
    allProductBtns.forEach((productBtn) => {
      productBtn.classList.remove("icon-circle--active");
    });

    if (!clickedProductBtn.classList.contains("icon-circle--active")) {
      clickedProductBtn.classList.add("icon-circle--active");
    }

    const slideIndex = clickedProductBtn.getAttribute("data-slide-index");
    const carousel = this.currentSwiper;
    carousel.swiperElement.slideTo(parseInt(slideIndex));
  }
}

customElements.define("shop-the-look-section", ShopLookSection);

class UspSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = null;
    this.enableSwiperControl = this.element.getAttribute("data-enable-swiper");
    this.paginationContainer = this.element.querySelector(
      ".usp-section__swiper-wrapper"
    );
    this.fallbackSlides = this.element.querySelector("#fallback-slides");

    this.updateIsMobile();
    this.updateSwiperControl();
    this.bindEvents();

    window.addEventListener("resize", () => {
      this.updateIsMobile();
      this.updateSwiperControl();
    });
  }

  bindEvents() {
    this.initSwiper = this.initSwiper.bind(this);
    this.destroySwiper = this.destroySwiper.bind(this);
    this.showSwiper = this.showSwiper.bind(this);
    this.hideSwiper = this.hideSwiper.bind(this);
  }

  updateIsMobile() {
    this.isMobile = responsive.matchesBreakpoint("pocket");
  }

  updateSwiperControl() {
    const slides = this.carouselElement.querySelectorAll(".swiper-slide");
    if (
      this.enableSwiperControl === "true" &&
      this.isMobile &&
      slides.length > 1
    ) {
      this.showSwiper();
      this.initSwiper();
    } else {
      this.destroySwiper();
      this.hideSwiper();
    }
  }

  initSwiper() {
    if (!this.carousel) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
  }

  destroySwiper() {
    if (this.carousel) {
      this.carousel.swiperElement.destroy(true, true);
      this.carousel = null;
    }
  }

  showSwiper() {
    this.carouselElement.style.display = "block";
    this.paginationContainer.style.display = "flex";
    this.fallbackSlides.style.display = "none";
  }

  hideSwiper() {
    this.fallbackSlides.style.display = "flex";
    this.carouselElement.style.display = "none";
    this.paginationContainer.style.display = "none";
  }
}
customElements.define("usp-section", UspSection);

class QuoteSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.enableAnimation = this.element.getAttribute("animation-toggle");
    this.targetParagraph = this.element.querySelector("#quote__paragraph");

    this.runAnimation = this.runAnimation.bind(this);

    if (this.enableAnimation === "true") {
      this.runAnimation();
    }
  }

  runAnimation() {
    if (this.targetParagraph) {
      const textElement = this.targetParagraph;
      const text = textElement.textContent;
      textElement.textContent = "";
      text.split("").forEach((letter) => {
        const span = document.createElement("span");
        span.textContent = letter;
        span.className = "letter";
        textElement.appendChild(span);
      });
      const letters = Array.from(this.element.querySelectorAll(".letter"));
      const animateLetters = (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            letters.forEach((letter, index) => {
              setTimeout(() => {
                letter.classList.add("colored");
              }, index * 25);
            });
            observer.unobserve(textElement);
          }
        });
      };

      const observer = new IntersectionObserver(animateLetters, {
        threshold: 0.1,
      });

      observer.observe(textElement);
    }
  }
}
customElements.define("quote-section", QuoteSection);

class CountryModal extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    new RevolutionSelectbox(this.element.querySelector(".RevolutionSelectbox"));

    this.bindEvents();
  }

  bindEvents() {
    this.handleCountrySelectListener = this.handleCountrySelect.bind(this);
    document.addEventListener(
      "change:countrySelector",
      this.handleCountrySelectListener
    );
  }

  handleCountrySelect() {
    this.updateLanguageOptions(event.detail.languages);
    const currency = event.detail.currency;
    document.querySelector(".country-selector--currency-iso_code").innerText =
      currency;
  }

  updateLanguageOptions(languagesJSON) {
    // Parse the JSON data
    const languages = JSON.parse(languagesJSON);

    // Get the container where the radio buttons will be appended
    const container = this.element.querySelector(
      ".country-selector--lanugage-inputs"
    );
    let containerPopup = container.closest(".country-selector--content");
    const startingHeight = containerPopup.offsetHeight;
    const modal = this.element.closest("#modal-country");
    modal.style.height = startingHeight + "px";
    container.innerHTML = ""; // Clear existing content

    // Loop through each language and create elements
    languages.forEach((language, index) => {
      const radioInput = document.createElement("input");
      radioInput.setAttribute("type", "radio");
      radioInput.setAttribute("id", `country-code-${language.iso}`);
      radioInput.setAttribute("class", "country-code--language-input");
      radioInput.setAttribute("name", "language_code");
      radioInput.setAttribute("value", language.iso);
      if (index == 0) {
        radioInput.setAttribute("checked", "checked");
      }
      const label = document.createElement("label");
      label.setAttribute("class", "country-selector--input-label u-p3");
      label.setAttribute("for", `country-code-${language.iso}`);
      const localeCircleSelected = document.createElement("div");
      localeCircleSelected.setAttribute("class", "locale_circle_selected");
      localeCircleSelected.innerHTML = `<svg class="Svg Svg--check " width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.11108 10C1.11108 5.0908 5.09078 1.11111 9.99997 1.11111C12.3575 1.11111 14.6184 2.04762 16.2854 3.71461C17.9524 5.3816 18.8889 7.64252 18.8889 10C18.8889 14.9092 14.9092 18.8889 9.99997 18.8889C5.09078 18.8889 1.11108 14.9092 1.11108 10ZM8.50553 14.3111L15.8055 7.01667L15.8166 7.02778C16.1235 6.72095 16.1235 6.22349 15.8166 5.91667C15.5098 5.60984 15.0124 5.60984 14.7055 5.91667L8.51664 12.1L5.30553 8.88889C4.9987 8.58206 4.50124 8.58206 4.19442 8.88889C3.88759 9.19571 3.88759 9.69318 4.19442 10L8.50553 14.3111Z" fill="black"></path>
      </svg>`;

      if (languages.length > 1) {
        const localeCircle = document.createElement("div");
        localeCircle.setAttribute("class", "locale_circle");
        localeCircle.appendChild(localeCircleSelected);
        label.appendChild(localeCircle);
      } else {
        label.classList.add("country-selector--input-label--single");
      }

      label.innerHTML += language.name.toUpperCase(); // Use innerHTML to append

      container.appendChild(radioInput);
      container.appendChild(label);
      requestAnimationFrame(() => {
        modal.style.height =
          document.querySelector(".country-selector--content").scrollHeight +
          "px";
      });
    });
  }
}
customElements.define("country-modal", CountryModal);

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.productId = this.element.getAttribute("data-product-id");
    this.sectionId = this.element.getAttribute("data-section");
    this.swipers = this.element.querySelectorAll(".swiper");
    this.swipers.forEach(swiper => new RevolutionSwiper(swiper));

    this.variantsContainer = this.element.querySelector(
      ".variants-desktop-container"
    );
    this.variantsColorContainer = this.element.querySelector(
      ".product-selector-desktop--color"
    );
    this.textField = this.element.querySelector(".card-information__container");
    this.productImageContainer = this.element.querySelector(
      ".cardProduct--Inner"
    );

    this.whenClosed = false;

    this.checkRating();

    new AddToCart(this.element);
    this.bindEvents();
  }

  bindEvents() {
    this.switchProductBinder = this.switchProduct.bind(this);
    this.closeProductDrawerBinder = this.closeProductDrawer.bind(this);
    this.openDrawerBinder = this.openProductDrawer.bind(this);

    responsive.addBreakpointListener("lap_and_up");
    this.delegateBody.on("breakpoint:lap_and_up", this.initListeners.bind(this));
    this.initListeners();

    this.delegateElement.on(
      "click",
      `[data-action="switch-product"]`,
      this.switchProduct.bind(this)
    );
  }

  initListeners() {
    if (responsive.matchesBreakpoint("pocket")) {
      this.delegateBody.on(
        "product-card-overlay:close",
        this.closeProductDrawerBinder
      );

      this.delegateElement.on(
        "click",
        "[data-toggle-template=toggle-template]",
        this.openDrawerBinder
      );
    } else {
      this.delegateBody.off(
        "product-card-overlay:close",
        this.closeProductDrawerBinder
      );

      this.delegateElement.off(
        "click",
        "[data-toggle-template=toggle-template]",
        this.openDrawerBinder
      );
    }
  }

  checkRating() {
    const targetNode = this.element;
    const iconRating = this.element.querySelector(".Svg--star");
    const ratingElement = this.element.querySelector(
      ".cardInformation--Actions"
    );

    const config = { childList: true, subtree: true };
    const callback = (mutationsList, observer) => {
      for (let mutation of mutationsList) {
        if (mutation.type === "childList") {
          const reviewsText = this.element.querySelector('.sr-only');
          if (reviewsText) {
            ratingElement.style.display = "";

            const numberMatch = reviewsText.innerHTML.match(/\d+(\.\d+)?/);

            if (numberMatch) {
              reviewsText.textContent = numberMatch[0];
            }
            observer.disconnect();
            break;
          } else {
            ratingElement.style.display = "none";
          }

          const productRating = this.element.querySelector(
            ".yotpo-reviews-star-ratings-widget"
          );
          if (productRating) {
            ratingElement.style.display = "";

            const productRatingText = this.element.querySelector(
              ".yotpo-sr-bottom-line-right-panel"
            );
            const productRatingScore = this.element.querySelector(
              ".yotpo-sr-bottom-line-score"
            );
            if (!productRatingScore) {
              ratingElement.style.display = "none";
            }
            if (productRatingText) {
              ratingElement.style.display = "none";
            }

            observer.disconnect();
            break;

          } else {
            ratingElement.style.display = "none";
          }
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

  removeExistingDrawer() {
    const existingDrawer = document.querySelector(
      ".product-card__mobile-drawer"
    );
    if (existingDrawer) {
      this.delegateBody.off(
        "click",
        `[data-action="switch-product"]`,
        this.switchProductBinder
      );

      existingDrawer.remove();
    }
  }

  openProductDrawer() {
    this.removeExistingDrawer();
    const node = document.createElement("div");
    node.classList.add("product-card__mobile-drawer");
    const templateToClone = this.element.querySelector("template").content;
    const clonedContent = templateToClone.cloneNode(true);
    node.appendChild(clonedContent);
    document.body.appendChild(node);
    new AddToCart(node);
    this.delegateBody.on(
      "click",
      `[data-action="switch-product"]`,
      this.switchProductBinder
    );
    this.drawer = new Drawer(
      document.querySelector(`#product-card-overlay`)
    );
  }

  closeProductDrawer() {
    if (this.whenClosed) {
      this.switchCard(this.newProductCard);
      this.whenClosed = false;
    }

    setTimeout(() => {
      this.removeExistingDrawer();
    }, 150);
  }

  switchDrawerContent(newProductCard) {
    if (responsive.matchesBreakpoint('pocket')) {
      const existingForm = document.querySelector(
        ".product-card__mobile-drawer .selector-form"
      );
      this.dropdownStates = {};
      this.memorizeDropdownStates(existingForm);
      const newDrawerElement = newProductCard.querySelector('template').content;
      const selectorForm = newDrawerElement.querySelector(`.selector-form`);
      const clonedForm = selectorForm.cloneNode(true);
      this.restoreDropdownStates(clonedForm);
      if (!selectorForm) return;
      existingForm.parentElement.replaceChild(clonedForm, existingForm);
      new AddToCart(selectorForm);

      this.delegateBody.on(
        "click",
        `[data-action="switch-product"]`,
        this.switchProductBinder
      );
    }
  }

  memorizeDropdownStates(element) {
    const dropdowns = element.querySelectorAll('.Dropdown--Button');

    dropdowns.forEach(dropdown => {
      const id = dropdown.closest('.Dropdown').getAttribute('data-id');
      const isOpen = dropdown.getAttribute('aria-expanded') === 'true';
      this.dropdownStates[id] = isOpen;
    });
  }
  restoreDropdownStates(element) {
    const dropdowns = element.querySelectorAll('.Dropdown--Button');

    dropdowns.forEach(dropdown => {
      const id = dropdown.closest('.Dropdown').getAttribute('data-id');
      const isOpen = this.dropdownStates[id];

      if (isOpen !== undefined) {
        // Set the aria-expanded attribute to reflect the memorized state
        dropdown.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        // Toggle the visibility of the dropdown content based on the state
        const content = dropdown.closest('.Dropdown').querySelector('.Dropdown--Content');
        if (content) {
          content.setAttribute('aria-hidden', isOpen ? 'false' : 'true'); // Manage aria-hidden
        }
      }
    });
  }

  switchCard(newProductCard) {
    newProductCard.querySelectorAll('.no-transition').forEach(el => el.style.transition = 'none');
    this.element.replaceWith(newProductCard);
    this.element = newProductCard;
    setTimeout(() => {
      this.element.querySelectorAll('.no-transition').forEach(el => el.style.transition = '');
    }, 50);
    this.productId = this.element.getAttribute("data-product-id");
    this.variantsContainer = this.element.querySelector(
      ".variants-desktop-container"
    );
    this.variantsColorContainer = this.element.querySelector(
      ".product-selector-desktop--color"
    );
    this.textField = this.element.querySelector(
      ".card-information__container"
    );
    this.productImageContainer = this.element.querySelector(
      ".cardProduct--Inner"
    );
    this.sectionName = this.element.getAttribute("[data-yotpo-section-id]");

    if (typeof window['yotpo'] !== 'undefined') {
      window['yotpo'].initWidgets();
    } else {
      yotpoWidgetsContainer.initWidgets();
    }
    this.checkRating();
  }

  switchProduct(event) {
    const color_id = event.target.dataset.id;
    const url = `${window.routes.rootUrl}search?view=product-card&q=id:${color_id}`;

    this.delegateBody.off(
      "click",
      `[data-action="switch-product"]`,
      this.switchProductBinder
    );

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        const htmlDocument = new DOMParser().parseFromString(html, "text/html");
        this.newProductCard = htmlDocument.querySelector(
          `#product-card-${color_id}`
        );

        if (responsive.matchesBreakpoint('pocket')) {
          this.switchDrawerContent(this.newProductCard);
          this.whenClosed = true;
        } else {
          this.switchCard(this.newProductCard);
        }
      })
      .catch((error) => console.error("Error fetching product:", error));
  }
}

customElements.define("product-card", ProductCard);

sessionStorage.setItem("firstLoadRecomm", true);
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    if (sessionStorage.getItem("firstLoadRecomm") !== "true") return;
    sessionStorage.setItem("firstLoadRecomm", false);

    this.delegateBody = new Delegate(document.body);
    new RevolutionSwiper(this.querySelector(".swiper"));

    this.loadRecommendations(this.dataset.url);
    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      'recommendations:reload',
      this.reloadRecommendations.bind(this)
    );
  }

  reloadRecommendations(e) {
    const productId = e.detail;
    const url = this.dataset.urlTemplate.replace("PRODUCT_ID", productId);
    this.loadRecommendations(url);
  }

  async loadRecommendations(url) {
    try {
      const response = await fetch(url);
      const text = await response.text();

      const html = document.createElement("div");
      html.innerHTML = text;

      const recommendations = html.querySelector("product-recommendations");

      if (recommendations && recommendations.innerHTML.trim().length) {
        this.innerHTML = recommendations.innerHTML;
        new RevolutionSwiper(this.querySelector(".swiper"));

        if (typeof window['yotpo'] !== 'undefined') {
          window['yotpo'].initWidgets();
        } else {
          yotpoWidgetsContainer.initWidgets();
        }
      }
    } catch (e) {
      console.error(e);
    }
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class Loader extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    if (this.dataset.first === "true") {
      // Checks if we opened site in a new tab
      const loaderShown = localStorage.getItem("loader_shown");
      localStorage.setItem("loader_shown", "true");

      if (loaderShown) {
        new RevolutionAnimation();
        this.element.remove();
        return;
      }
    } else {
      // Checks if we refreshed the page
      const pageAccessedByReload =
        (window.performance.navigation &&
          window.performance.navigation.type === 1) ||
        window.performance
          .getEntriesByType("navigation")
          .map((nav) => nav.type)
          .includes("reload");

      // Checks if we opened site in a new tab
      const isNewTab = sessionStorage.getItem("is_old_tab") != "true";
      sessionStorage.setItem("is_old_tab", "true");

      if (!isNewTab && !pageAccessedByReload) {
        new RevolutionAnimation();
        this.element.remove();
        return;
      }
    }

    this.bindEvents();
  }

  hideLoader() {
    this.element.style.opacity = "0";

    function onTransitionEnd() {
      this.element.remove();
      new RevolutionAnimation();
      this.element.removeEventListener("transitionend", onTransitionEnd);
    }

    this.element.addEventListener("transitionend", onTransitionEnd);
  }

  bindEvents() {
    window.addEventListener("load", () => {
      setTimeout(() => this.hideLoader(), 500);
    });
  }
}

customElements.define("loader-element", Loader);

class PointsSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    if (responsive.matchesBreakpoint("lap_and_up")) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.delegateElement.on(
      "mouseover",
      ".points-wrapper__point-block",
      this.displayContent.bind(this)
    );
    this.delegateElement.on(
      "mouseout",
      ".points-wrapper__point-block",
      this.hideContent.bind(this)
    );

    // Focusin and Focusout for keyboard accessibility
    this.delegateElement.on(
      "focusin",
      ".points-wrapper__point-block",
      this.displayContent.bind(this)
    );
    this.delegateElement.on(
      "focusout",
      ".points-wrapper__point-block",
      this.hideContent.bind(this)
    );
  }

  displayContent() {
    const wrapper = event.target.closest(".points-wrapper__point-block");
    const text = wrapper.querySelector(".point-block__content");
    const primaryImg = wrapper.querySelector(".point-block__image-container");

    const width = wrapper.offsetWidth;
    const height = wrapper.offsetHeight;

    const image = wrapper.querySelector(
      ".point-block__background-image-container"
    );

    if (image && text) {
      image.setAttribute("aria-hidden", "false");

      image.style.width = `${width}px`;
      image.style.height = `${height}px`;
    }

    if (text) {
      text?.setAttribute("aria-hidden", "false");
      if (primaryImg) {
        primaryImg.setAttribute("aria-hidden", "true");
        primaryImg.style.display = 'none';
      }
      const title = wrapper.querySelector(".point-block__title");
      title?.setAttribute("aria-hidden", "true");

      const paragraph = wrapper.querySelector(".point-block__text");
      paragraph?.setAttribute("aria-hidden", "true");
    }
  }

  hideContent() {
    const wrapper = event.target.closest(".points-wrapper__point-block");
    const text = wrapper.querySelector(".point-block__content");
    const primaryImg = wrapper.querySelector(".point-block__image-container");
    const image = wrapper.querySelector(
      ".point-block__background-image-container"
    );

    if (text) {
      if (primaryImg) {
        primaryImg?.setAttribute("aria-hidden", "false");
        primaryImg.style.display = 'block';
      }
      image?.setAttribute("aria-hidden", "true");
      text?.setAttribute("aria-hidden", "true");

      const title = wrapper.querySelector(".point-block__title");
      title?.setAttribute("aria-hidden", "false");

      const paragraph = wrapper.querySelector(".point-block__text");
      paragraph?.setAttribute("aria-hidden", "false");
    }

  }
}
customElements.define("section-points", PointsSection);

class InfiniteScroll {
  constructor(container, restoreState) {
    this.containerSelector = container;
    this.treshold = 650;
    this.handleClickListener = this.handleClick.bind(this);
    this.domDelegate = new Delegate(document.body);

    if (restoreState == true && sessionStorage.getItem("pageState")) {
      const promises = this.generateFetchPromises(false);
      this.renderData(promises, true);
    } else {
      this.initialize();
    }
  }

  initialize() {
    this.domDelegate.on(
      "click",
      '[data-action="load"]',
      this.handleClickListener
    );
  }

  handleClick() {
    event.preventDefault();

    event.target
      .closest("a")
      .querySelector(".itemLoader")
      .classList.add("is-visible");

    this.paginationElement = document.querySelector("#infinite-scroll");
    if (!this.paginationElement) return;

    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    if (this.nextPageLinkElement) {
      this.destroy();
      const nextPageUrl = this.nextPageLinkElement.href;

      const promises = this.generateFetchPromises(nextPageUrl);
      this.renderData(promises);
    }
  }

  destroy() {
    // Remove the event listener when the instance is no longer needed
    this.domDelegate.off(
      "click",
      '[data-action="load"]',
      this.handleClickListener
    );
  }

  generateFetchPromises(nextPageUrl) {
    const promises = [];

    if (nextPageUrl == false) {
      const hasSearchParameters = window.location.search.length > 0;
      const limit = parseInt(sessionStorage.getItem("pageState"));
      for (let i = 2; i <= limit; i++) {
        let url;

        // Build the URL based on the condition
        if (hasSearchParameters) {
          url = `${window.location.href}&page=${i}`;
        } else {
          url = `${window.location.href}?page=${i}`;
        }

        promises.push(
          fetch(url, {
            credentials: "same-origin",
            method: "GET",
          })
        );
      }
    } else {
      const url = `${nextPageUrl}`;

      promises.push(
        fetch(url, {
          credentials: "same-origin",
          method: "GET",
        })
      );
    }

    return promises;
  }

  async renderData(promises, restoreContent) {
    try {
      const responses = await Promise.all(promises);
      const contents = await Promise.all(
        responses.map((response) => response.text())
      );
      let isLastPromise = false;
      contents.forEach((content, index) => {
        isLastPromise = index === contents.length - 1;
        this.appendContent(content, isLastPromise, restoreContent);
      });
    } catch (error) {
      console.error("Error fetching or parsing data:", error);
    }
  }

  appendContent(content, lastPromise, restoreContent) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");
    const contentToAdd = doc.querySelector(this.containerSelector);

    this.mainContainer = document.querySelector(this.containerSelector);
    this.paginationElement =
      this.mainContainer.querySelector("#infinite-scroll");
    if (this.paginationElement) {
      this.paginationElement.remove();
    }

    this.mainContainer.insertAdjacentHTML("beforeend", contentToAdd.innerHTML);

    if (lastPromise) {
      this.initialize();
    }

    if (lastPromise && restoreContent) {
      this.restoreScroll();
    }

    document.dispatchEvent(
      new CustomEvent("pagination:finished", { bubbles: true })
    );

    new RevolutionAnimation(this);
    if (typeof window['yotpo'] !== 'undefined') {
      window['yotpo'].initWidgets();
    } else {
      yotpoWidgetsContainer.initWidgets();
    }
  }
  restoreScroll() {
    const selector = `${this.containerSelector
      } [data-id='${sessionStorage.getItem("pageStateProduct")}']`;
    const targetElement = document.querySelector(selector);
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth", // You can use 'auto' for instant scrolling
        block: "start", // You can use 'center' or 'end' for different alignments
      });
    }
  }
}

class BlogShowcaseSlider extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carousel = this.element.querySelector(".swiper");

    new RevolutionSwiper(this.carousel);
  }
}

customElements.define("blog-showcase", BlogShowcaseSlider);

class BlogSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".blog__tags--swiper.swiper");
    this.activeSlide = this.element.querySelector(".blog__current-tag");
    this.breakpoint = new Responsive().getCurrentBreakpoint();
  }

  connectedCallback() {
    new InfiniteScroll('#blog-article--wrapper', '#infinite-scroll', true);
    if (this.carouselElement && this.breakpoint === "phone" || this.breakpoint === "pocket") {
      const swiperElement = new RevolutionSwiper(this.carouselElement);
      const slides = Array.from(this.carouselElement.querySelectorAll(".swiper-slide"));
      const activeIndex = slides.indexOf(this.activeSlide);

      swiperElement.swiperElement.slideTo(activeIndex)
    }
  }
}

customElements.define("blog-section", BlogSection);

class CollectionShowcaseSlider extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.initSwiper();
    this.buttonsActive();
    this.bindEvents();
  }

  buttonsActive() {
    const buttons = this.element.querySelectorAll(".buttons-container");

    buttons[0].classList.add("button-active");
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=change-tab]",
      this.buttonClickHandle.bind(this)
    );
  }

  initSwiper() {
    if (responsive.matchesBreakpoint("pocket")) {
      if (this.currentSwiper) {
        this.currentSwiper.swiperElement.destroy(true, false);
      }
      this.carousel = this.element.querySelector(
        '.swiper[aria-hidden="false"]'
      );
      this.currentSwiper = new RevolutionSwiper(this.carousel);
    }
  }

  buttonClickHandle() {
    const clickedButton = event.target;
    const targetId = clickedButton.getAttribute("data-target");
    const buttonAnimationDiv = this.element.querySelector(".buttons-animation");
    const block = this.element.querySelector(
      '.collection-blocks[aria-hidden="false"]'
    );

    block?.setAttribute("aria-hidden", "true");

    const targetBlock = this.element.querySelector(`[data-id="${targetId}"]`);

    targetBlock?.setAttribute("aria-hidden", "false");

    const buttons = this.element.querySelectorAll(".buttons-container");

    buttons.forEach((button) => {
      button.classList.remove("button-active");
    });

    setTimeout(function () {
      clickedButton.classList.add("button-active");
    }, 50);

    const buttonWidth = clickedButton.offsetWidth;
    const buttonLeft = clickedButton.offsetLeft;

    buttonAnimationDiv.style.width = `${buttonWidth}px`;
    buttonAnimationDiv.style.transform = `translateX(${buttonLeft}px)`;

    this.initSwiper();
  }
}
customElements.define("collection-showcase-slider", CollectionShowcaseSlider);

class CollectionShowcaseSliderBig extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carousels = [];
    this.delegateElement = new Delegate(this.element);

    if (new Responsive().matchesBreakpoint("pocket")) {
      this.carousels[0] = new RevolutionSwiper(
        this.element.querySelector(".swiper")
      );
    }
  }
}
customElements.define(
  "collection-showcase-slider-big",
  CollectionShowcaseSliderBig
);

class ImageTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.sectionId = this.element.getAttribute("section-data");
    setTimeout(() => {
      this.contentWrapper = this.querySelector(
        ".text-position-" +
        this.sectionId +
        "--text_over_image .content-wrapper"
      );
      this.videoContainers = this.querySelectorAll(".media-parent-container");

      this.visibleVideoContainer = null;

      this.videoContainers.forEach((container) => {
        if (window.getComputedStyle(container).display !== "none") {
          this.visibleVideoContainer = container;
        }
      });
      if (this.contentWrapper && this.visibleVideoContainer) {
        if (
          this.contentWrapper.offsetHeight >=
          this.visibleVideoContainer.offsetHeight
        ) {
          this.contentWrapper.classList.add("content-too-big");
        }
      }
    }, 100);
  }
}

customElements.define("image-text-section", ImageTextSection);

class NotifyMe extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.allNotifications = this.element.querySelectorAll(
      ".product-module__notify-action"
    );

    this.productId = document.querySelector(
      'form[data-product-form] [name="id"]'
    ).dataset.productid;
    this.variantId = document.querySelector(
      '[name="notify_variant"]'
    ).dataset.id;

    this.bindEvents();
  }

  bindEvents() {
    this.onClickOutsideListener = this.closeNotifyMe.bind(this);

    this.delegateBody.on(
      "click",
      '[data-action="notify-open"]',
      this.openNotifyMe.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="subscribe"]',
      this.handleSubscribe.bind(this)
    );
    this.delegateBody.on("notify:change", this.updateVariantId.bind(this));
    this.delegateElement.on(
      "click",
      '[data-action="notify-close"]',
      this.closeNotifyMe.bind(this)
    );
  }

  updateVariantId(e) {
    this.variantId = e.detail.id;
  }

  handleSubscribe() {
    const email = this.element.querySelector('[name="notify_email"]').value;
    let promise = SI.create(email, this.variantId, this.productId);

    if (email !== "" && email.includes("@")) {
      promise.then((st, data) => {
        let resp = SI.parseJSON(data);
        if (resp.status == "OK") {
          this.showNotification("success");
        } else {
          this.showNotification("error");
        }
      });
    } else {
      this.showNotification("email-error");
    }
  }

  clearNotifications() {
    this.allNotifications.forEach((el) =>
      el.setAttribute("aria-hidden", "true")
    );
  }

  showNotification(string) {
    this.clearNotifications();

    let activeNotification;
    switch (string) {
      case "success":
        activeNotification = this.element.querySelector(
          ".product-module__notify-action--success"
        );
        break;

      case "email-error":
        activeNotification = this.element.querySelector(
          ".product-module__notify-action--email-error"
        );
        break;

      default:
        activeNotification = this.element.querySelector(
          ".product-module__notify-action--error"
        );
        break;
    }

    activeNotification.setAttribute("aria-hidden", "false");
  }

  openNotifyMe(e) {
    e.preventDefault();
    this.element.setAttribute("aria-hidden", "false");
    trapFocus(this.element);

    this.pageOverlayElement.classList.add("is-visible");
    bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);

    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
  }

  closeNotifyMe(e) {
    this.element.setAttribute("aria-hidden", "true");

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );

    // Remove scrolllock and clear notifications after the popup disappears so there are no visible layout shifts
    this.element.addEventListener(
      "transitionend",
      () => {
        if (e.target.closest('[data-action="notify-close"]')) {
          setTimeout(() => {
            bodyScrollLock.enableBodyScroll(
              this.element,
              bodyScrollLockOptions
            );
            this.clearNotifications();
          }, 50);
        } else {
          bodyScrollLock.enableBodyScroll(this.element, bodyScrollLockOptions);
          this.clearNotifications();
        }
      },
      { once: true }
    );
  }
}

customElements.define("notify-me-popup", NotifyMe);

document.querySelectorAll('.shopify-app-block').forEach(block => {
  block.setAttribute('data-animation', 'elementFromBottom');
  block.classList.add('animatedContent');
  new RevolutionAnimation(block, true);
});